import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading'
import Printd from 'printd'
import VueBarcode, { data } from 'vue-barcode'
import PageTracker from '../../../common/PageTrackerHelper';
import pendingPods from '../common/pendingPods'
import pendingGroupIdShipments from '../common/pendingGroupIdShipments'
import tableTemplate from '../common/table-template'
// import { Map } from 'vuelayers'
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LPolyline } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { latLng } from "leaflet";
import { Icon } from 'leaflet';
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import keycloak from '../../../common/Keycloak';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  iconSize: [20, 30],
  shadowSize: [30, 30]
});

export default {
  name: 'Allocation',
  components: {
    // Map,
    "v-marker-cluster": Vue2LeafletMarkerCluster,
    'l-map': LMap,
    'l-tile-layer': LTileLayer,
    'l-marker': LMarker,
    'l-popup': LPopup,
    'l-tooltip': LTooltip,
    LPolyline,
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading,
    'barcode': VueBarcode,
    'pending-Pods' : pendingPods,
    'pending-group-id-shipment' : pendingGroupIdShipments,
    'load-table-template' : tableTemplate,
  },
  mixins:[PageTracker],
  data: function() {
    return {
      zoom: 11,
      center: latLng(18.516726, 73.856255),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      // attribution:
      //   '&copy; <a href="#">Xpressbees</a> contributors',
      // withPopup: latLng(18.516726, 73.856255),
      // withTooltip: latLng(19.076090, 72.877426),
      currentZoom: 11,
      currentCenter: latLng(18.516726, 73.856255),
      mapOptions: {
        zoomSnap: 0.5
      },
      showMap: true,
      barcodeValue: '11419106696',
      tripTitle:'Start Trip',
      srId:'',
      srId1:'',
      srList:[],
      routeId:'',
      routeId1:'',
      routeId2:'',
      routeId3:'',
      routeList:[],
      routeItemObj:{ value: "",text: ""},
      routeItemObj1:{ value: "",text: ""},
      routeItemObj2:{ value: "",text: ""},
      routeItemObj3:{ value: "",text: ""},
      srItemObj:{ value: "",text: ""},
      srItemObj1:{ value: "",text: ""},
      vehicleNo:'',
      vehicleOpenKM:'',
      deliveryOptionList:[{ text: "RTO"},{ text: "DTO"},{ text: "RVP"},{ text: "Delivery"},],
      deliveryOptionListPrint:[{ text: "RTO"},{ text: "DTO"},{ text: "RVP"},{ text: "Delivery"}],
      deliveryOptionItemObj:{ text: ""},
      deliveryOption:'',
      deliveryOptionItemObjPrint:{ text: ""},
      deliveryOptionPrint:'',
      clientOptionList:[],
      clientOptionItemObj:{ value: "",text: ""},
      clientOption:'',
      srHubName:'',
      RouteHubName:'',
      srName:'',
      shipmentNo:'',
      startTripFlag:false,
      vehicleTypeFlag:false,
      vehicleType:'',
      srVehicleList:[],
      vehicleNoItemObj:{value:'', text: ''},
      startAllocationFlag:false,
      isAllocation:false,
      srShipmentList:[],
      pendingShipmentList:[],
      pendingShipmentListMdl:[],
      srArrayList:[],
      errVehicleNo:'',
      isRSVSr:0,
      errVehicleKm:'',
      closeTripModel:false,
      openKmImg:'',
      openKm:'',
      closeKmImg:'',
      closeKm:'',
      latitude:'',
      longitude:'',
      tripId: '',
      srVehicleNo:'',
      originCloseImg:'',
      errorCloseKM: '',
      tripState: '',
      vehicleVendorId: '',
      isVehicleReplaced: false,
      isVehicleReplacedCheck: 0,
      isLoadingASL:false,
      loader:'<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      srLoader:'',
      isLoadingAlc:false,
      totalPendingShipment:0,
      pageCount: 0,
      pageNo: 1,
      pageNoMdl:1,
      pageCountMdl:0,
      isLoadingPSL:false,
      pendingShipModel:false,
      isLoadingPSLModel:false,
      totalPendingShipmentMdl:0,
      srIdFlt:'',
      srListFlt:[],
      srItemObjFlt:{ value: "",text: ""},
      routeListFlt:[],

      fromListFlt:[
                    //{ value: null,text: "All"},
                  //  { value: "FromMob",text: "From Mobile"},
                    { value: "FromWeb",text: "From Web"}],
      fromItemObjFlt:{ value: "FromWeb",text: "From Web"},
      fromIdFlt:null,
      fromList:[{ value: "UA",text: "From Mobile"},{ value: "Web",text: "From Web"}],
      fromItemObj:{ value: "UA",text: "From Mobile"},
      fromId:"UA",
      srShipmentPrintList:[],
      isLoadingPrint:false,
      createdBy:'',
      srNameShipPrint:'',
      srPhoneShipPrint:'',
      flagShowPreviousShipment:false,
      showShipmentModel:false,
      showShipmentList:[],

      dismissSecs: 20,
      dismissCountDown: 0,
      allocationErrorMsg: "",
      dismissCountDownSuccess:0,
      allocationSuccessMsg: "",
      successAllocationCount: "",
      errorAllocationCount: "",
      fieldErr:false,

      rtoDtoSheetTitle:'RTO Sheet',
      rtoDtoDrsTitle:'RTO DRS',
      rtoDRSBatchId:'',
      rtoDRSClientName:'',
      rtoDRSVendorName:'',
      rtoDRSWHHandOverPersonName:'',

      rtoRunSTHubName:'',
      rtoRunSTDrsNo:'',

      printDType:'',
      rvpShipmentsModel:false,

      fromToDate:'',
      fltpickup:'Pending',
      sAll: false,
      sAllMoreShip: false,
      selectedPickups: [],
      selectedPickupsMore:[],
      pickupList:[],
      pickupData:[{value:'Pending',text:'All Pending'},{value:'PendingNewPickUp',text:'Pending New PickUp To Assign'},{value:'PendingReAssigned',text:'Pending Re-Assign  For PickUp'}],
      pickupItem:{value:'Pending',text:'All Pending'},
      isChecked:false,
      isLoadingRvpPickup:false,
      errorRvpAllocation:'',
      successRvpAllocation:'',
      isAllocationRvp:false,
      suggestRVPArrayList:[],
      morePendingRVPShipmentsModel:false,
      isActiveRvp:false,
      searchByShippingId: '',
      searchByShippingId1: '',
      searchByShippingId2: '',
      searchByShippingId3: '',
      searchByShippingId4: '',
      PsearchByShippingId: '',
      RVPAllocatedShipmentList: '',
      indexTab: 1,
      ShipmentindexTab : 1,
      currentTab:'Eligible Shipment List',
      ActiveTabIndex: 0,
      ShipmentFutureFailedArrObj:[],
      ShipmentFailedArrObj: [],
      errorRvpAllocationErrorArrobj :[],
      isResetLoad : false,
      isConfirmLoad: false,
      allocationLoader: false,
      styleObjectsp : {
        'background-color' : 'red'
      },
      styleObjectForTotalAttemptZero : {
        'background-color' : '#EE82EE'
      },
      styleObjectE: {
        'background-color' : '#FF7E00'
      },
      futurePickupStyle: {
        'background-color' : '#DEB887'
      },
      tripCreatedDate: '',
      currentDateTime: '',
      tripDayflag: '',
      tripDateFlag: false,
      IsRVPPaperless: false,
      IsSRNeedTrip: true,
      searchByShippingIdRvp: '',
      searchByShippingIdRvpASL: '',
      batchIdPrint:'',
      batchIdListPrint:[],
      batchIdItemObjPrint:{ text: ""},
      ebnVehicleNo: '',
      errEbnVehicleNo: '',
      flagShowEbnVehicleNo: false,
      RVPLink:'',
      apiPath:'',
      disableFrom:false,
      errorOpenKM: '',
      disableBatchID:false,
      isLoadBatch:false,
      disableHTMLPDF:false,
      isLoadPDF:false,
      shippingIDArray:[],
      batchCreatedDate:'',
      today:'',
      futuredate:false,
      pastdate:false,
      IsConfirmAllocation: false,
      PendingTabOptionKey: 0,
      PendingPopTabOptionKey: 0,
      mdlPopDeliveryOption: '',
      PopUpsearchByShippingId: '',
      PendingListdeliveryOpt: '',
      printType:'',
      showconfirmPrint : false,
      userid: '',
      IsPaperlessFlyerbarcode: false,
      errShipmentNo: '',
      isPodsLoader: false,
      IsPaperlessFlyerbarcode: false,
      userid: '',
      isGroupIdLoader: false,
      showGroupIdShipmentModel: false,
      showParentGroupIdShipmentList: [],
      pendingGrouptErrorMsg: '',
      IsLongPinCodeFlag: null,
      serviceCatagoryList:[{value:'LateEveningDelivery',text:'Late Evening Delivery'}],
      serviceCatagoryObj:{value:'',text:''},
      serviceCatagoryOption:'',
      routeName: '',
      RouteName: '',
      isCreate: false,
      buttonStatus : '',
      currenthubid : '',
      hubname : '',
      routeLoader: '',
      showRouteShipmentModel: false,
      ShowUnplannedShipmentModel: false,
      ShowPlannedShipmentModel: false,
      ShowEligibleShipmentModel: false,
      RemoveShipmentModal: false,
      showRouteShipmentList: [],
      showShipmentsList: [],
      EligibleShipmentList: [],
      UnplannedShipmentList: [],
      PlannedShipmentList: [],
      AssignedToSRList : [],
      RouteShipmentloader: false,
      // IsSelectRoute: false,
      IsSelectPlanned: false,
      UnplannedTab: false,
      PlannedTab: false,
      EligibleTableColumns: [
        // {
        //   "label": 'ShippingID',
        //   "key": "ShippingID"
        // },
        {
          "label": 'Route Id',
          "key": "RouteId"
        },
        {
          "label": 'Shipment type',
          "key": "ShipmentType"
        },
        // {
        //   "label": 'IsPlanned',
        //   "key": "IsPlanned"
        // },
        {
          "label": 'Last Status',
          "key": "ShipmentStatus"
        },
        {
          "label": 'Total Attempt',
          "key": "TotalAttempts"
        },
        {
          "label": 'Net Payment',
          "key": "NetPayment"
        },
        {
          "label": 'Order Type',
          "key": "OrderType"
        },
        {
          "label": 'Address Type',
          "key": "AddressType"
        },
        {
          "label": 'EDD',
          "key": "EDD",
          "function":"moment"
        },
        {
          "label": 'Customer Address',
          "key": "CustomerAddress"
        },
        {
          "label": 'Ship Pincode',
          "key": "ShipPincode"
        },        
      ],
      UnPlannedTableColumns: [
        // {
        //   "label": 'ShippingID',
        //   "key": "ShippingID"
        // },
        {
          "label": 'Shipment type',
          "key": "ShipmentType"
        },
        // {
        //   "label": 'IsPlanned',
        //   "key": "IsPlanned"
        // },
        // {
        //   "label": 'Status',
        //   "key": "Status"
        // },
        {
          "label": 'Last Status',
          "key": "ShipmentStatus"
        },
        {
          "label": 'Total Attempts',
          "key": "TotalAttempts"
        },
        {
          "label": 'Net Payment',
          "key": "NetPayment"
        },
        {
          "label": 'Order Type',
          "key": "OrderType"
        },
        {
          "label": 'Address Type',
          "key": "AddressType"
        },
        {
          "label": 'EDD',
          "key": "EDD"
        },

        {
          "label": 'Customer Address',
          "key": "CustomerAddress"
        },
        {
          "label": 'Ship Pincode',
          "key": "ShipPincode"
        }, 
      ],
      PlannedTableColumns: [
        // {
        //   "label": 'ShippingID',
        //   "key": "ShippingID"
        // },
        {
          "label": 'Shipment Type',
          "key": "ShipmentType"
        },
        // {
        //   "label": 'IsPlanned',
        //   "key": "IsPlanned"
        // },
        {
          "label": 'Last Status',
          "key": "ShipmentStatus"
        },
        {
          "label": 'Total Attempts',
          "key": "TotalAttempts"
        },
        // {
        //   "label": 'Status',
        //   "key": "Status"
        // },
        {
          "label": 'Route ID',
          "key": "RouteId"
        },
        {
          "label": 'Route Name',
          "key": "RouteName"
        },
        {
          "label": 'Customer Address',
          "key": "CustomerAddress"
        },
        {
          "label": 'Ship Pincode',
          "key": "ShipPincode"
        },
        {
          "label": 'Net Payment',
          "key": "NetPayment"
        },
        {
          "label": 'EDD',
          "key": "EDD"
        },
      ],
      PlannedTableColumnsWithOrderNo: [
        // {
        //   "label": 'ShippingID',
        //   "key": "ShippingID"
        // },
        {
          "label": 'Shipment Type',
          "key": "ShipmentType"
        },
        // {
        //   "label": 'IsPlanned',
        //   "key": "IsPlanned"
        // },
        {
          "label": 'Total Attempts',
          "key": "TotalAttempts"
        },
        // {
        //   "label": 'Status',
        //   "key": "Status"
        // },
        {
          "label": 'Route ID',
          "key": "RouteId"
        },
        {
          "label": 'Route Name',
          "key": "RouteName"
        },
        {
          "label": 'Net Payment',
          "key": "NetPayment"
        },
        {
          "label": 'EDD',
          "key": "EDD"
        },
        {
          "label": 'Sequence No',
          "key": "sequenceno"
        }
      ],
      AssignedToSRColumns:[
        // {
        //   "label": 'ShippingID',
        //   "key": "ShippingID"
        // },
        {
          "label": 'Shipment Type',
          "key": "ShipmentType"
        },
        {
          "label": 'Last Status',
          "key": "ShipmentStatus"
        },
        {
          "label": 'Route ID',
          "key": "RouteId"
        },
        {
          "label": 'Delivery UserID',
          "key": "DeliveryUserID"
        },
        {
          "label": 'Delivery User',
          "key": "DeliveryUserName"
        },
        {
          "label": 'Customer Address',
          "key": "CustomerAddress"
        },
        {
          "label": 'Ship Pincode',
          "key": "ShipPincode"
        },
        {
          "label": 'Service Type',
          "key": "ServiceType"
        },
        {
          "label": 'Net Payment',
          "key": "NetPayment"
        },
        {
          "label": 'EDD',
          "key": "EDD"
        },
      ],
      CreateAddRouteModel: false,
      Shipmentloader: false,
      isCreateRoute : false,
      selectedItemdata: [],
      selectedItems: [],
      selectedRoutedata: false,
      selectedRouteIds: [],
      PlannedMapView : false,
      PlannedListView : false,
      EditReAssignSRModel : false,
      EditReAssignSRModelLoader : false,
      PlannedRoutes : false,
      ActualRoute : false,
      ShowSR : false,
      UnassignedRoutes : false,
      currentScreenTab:'listview',
      filterShipmentType: ['Delivery'],
      deliveryTypeFilters: '',
      deliveryTypeFilters1:'',
      deliveryTypeFilters2:'',
      IsReload: false,
      successShipments: [],
      successAllocationCount: "",
      errorAllocationCount: "",
      IsAllocateShip: false,
      IsMaproute: false,
      ShowAssignedToSRShipmentModel: false,
      AssignedToSRLoader: false,
      ReasonOptionList:[{ text: "Incorrect location shared by locus"},{ text: "Physical constraints on ground"},{ text: "Incorrect Route"}],
      ReasonOptionItemObj:{ text: ""},
      ReasonOption:'',
      Reason: '',
      RemoveShipingId:'',
      RemoveRouteId: '',
      eligiblepagecount: 0,
      eligiblepageNo: 1,
      ShipmentCount: '',
      PageLimit: 10,
      PlUnPLpagecount: 0,
      UnPLpageNo: 1,
      UnPLpagecount: 0,
      PLpagecount: 0,
      PLpageNo: 1,
      PLRTpageno: 1,
      PLRTpagecount: 0,
      Allocatedpagecount: 0,
      AllocatedpageNo: 1,
      selectedShipments: '',
      selectedShipmentType: '',
      finalSelectedItems: [],
      selectedObj:{},
      isSequenceNo: false,
      EditSequenceNoModal: false,
      SequenceNoShipment: '',
      SequenceNo: '',
      Markers: [],
      Routes: [],
      PolyLines: [],
      isEditSeq: false,
      userDataKey : '',
    }
  },

  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    jsUcfirst: function(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    batchCreatedDateFormat:function(date){
      if(date==null)return ''
      return moment(date).format('DD-MM-YYYY');
    }
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    let setLocusFlag = await this.checkIsLocusEnableforhub()
    if(!setLocusFlag) {
      this.$alertify.error('Your are not authorized user/hub for locus module.!')
      this.$router.push('/dashboard')
      return false;
    }
    console.log('setLocusFlag ----->>', setLocusFlag);
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0]
    this.createdBy = userdetail.username;
    this.userid = userdetail.userid;

    const IsRVPPaperlessEncrypt = window.localStorage.getItem('IsRVPPaperless')
    const IsRVPPaperlessbytes = CryptoJS.AES.decrypt(IsRVPPaperlessEncrypt.toString(), this.userDataKey);
    const IsRVPPaperlessbytestext = IsRVPPaperlessbytes.toString(CryptoJS.enc.Utf8);
    const paperLessKey = JSON.parse(IsRVPPaperlessbytestext)
    //console.log('paperLessKey',paperLessKey);
    if(paperLessKey != null && paperLessKey.trim() == "1") {
      this.IsRVPPaperless = true;
      this.deliveryOptionListPrint.splice(2, 1) ;
    } else {
      this.IsRVPPaperless = false;
    }
    console.log('this.IsRVPPaperless',this.IsRVPPaperless);

    this.getHubName(this.userHubId)
    this.loadSRList(this.userHubId)
    this.loadRouteList(this.userHubId)
    this.vehicleNoRegExp = new RegExp('^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$');

    if(this.userHubId==1091) {
      var fromListFlt = this.fromListFlt.filter(n => {
        if(n.value!=null) {
          return n
        }
      })
      this.fromListFlt = fromListFlt
      this.fromItemObjFlt = { value: 'FromWeb',text: "From Web"}
      this.fromIdFlt = 'FromWeb'
    }

    // $(".shipmentListtab ul li:first").addClass("active");
    // console.log('test',$(".shipmentListtab ul li:first"));
    // this.loadPendingShipmentList('reload','delivery');
    this.ShowEligibleShipmentList();
    this.getShipmentForMap();

    let TrackerInfo = {
        projectname:"Last Mile",
        type:"Web",
        userid:this.userid,
        username:this.createdBy,
        meta: {
          "event":""
        }
    }
    this.switchPlannedAllocationPanel('listview')
    let result  = this.PageTracker(TrackerInfo);
    this.ShowAssignedToSRList();
    //console.log('Mixin is working for :',result);
  },
  updated() {
    if(this.ActiveTabIndex == 0){
      $('.shipmentListtab ul li a:first').addClass('active')
    }
  },
  computed: {
    flagAllocation() {
      // if(this.deliveryOption=="Delivery" || this.deliveryOption=="RVP" || this.deliveryOption=="RTO" || this.deliveryOption=="DTO") {
        let checkSpecialChars = /[!@#$%^&*`'[+~/(),.?":{}|<>]/;
        if( checkSpecialChars.test(this.shipmentNo)==false){
          var isComplete = this.shipmentNo // && this.deliverytype
          this.errShipmentNo = '';

        } else {
          this.errShipmentNo = 'Please Enter Valid Shipment No.!'
        }
      // }
      // if(this.deliveryOption=="Delivery") {
      //   var isComplete = this.deliveryOption && this.shipmentNo
      // } else {
      //   var isComplete = this.deliveryOption && this.clientOption && this.shipmentNo
      // }
      return isComplete
    },
    totalCODAmount() {
      var totalAmount = 0
      for (var i = 0; i < this.srShipmentPrintList.length; i++) {
        if(this.srShipmentPrintList[i].OrderType=="COD" || this.srShipmentPrintList[i].OrderType=="cod") {
          totalAmount += parseFloat(this.srShipmentPrintList[i].NetPayment)
        }
      }
      return totalAmount.toFixed(2);
    }
  },
  created() {
    // axios.interceptors.request.use((config) => {
    //   this.setLoading(true);
    //   return config;
    // }, (error) => {
    //   this.setLoading(false);
    //   return Promise.reject(error);
    // });
    //
    // axios.interceptors.response.use((response) => {
    //   this.setLoading(false);
    //   return response;
    // }, (error) => {
    //   this.setLoading(false);
    //   return Promise.reject(error);
    // });
  },
  methods: {
    AddShipment(){
      this.Shipmentloader = true;
      let payload = {
        "HubId" : this.userHubId,
        "ShippingId" : this.shipmentNo,
        "LastModifiedBy" : this.createdBy
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'routeplanner/addshipmentinlm',
        data: payload
      })
      .then(result => {
        if (result.data.code==200) {
          this.$alertify.success("Shipment added successfully");
        } 
        else if(result.data.message[0].message != null){
          this.$alertify.error(result.data.message[0].message);
        }
        else{
          this.$alertify.error('Invalid ShippingID.!');
        }
        this.shipmentNo = '';
        this.Shipmentloader = false;
        this.resetTrip();
      }, error => {
        console.error(error)
      })
    },            
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    jobTypefilterData(jobtype){
      if(this.ActiveTabIndex == 0){
        this.deliveryTypeFilters = jobtype
        this.ShowEligibleShipmentList()
      }
      if(this.ActiveTabIndex == 1){
        this.deliveryTypeFilters1 = jobtype
        this.ShowPlannedUnplannedShipments()
      }
      if(this.ActiveTabIndex == 2){
        this.deliveryTypeFilters2 = jobtype
        this.ShowPlannedUnplannedShipments()
      }
      // console.log('this.deliveryTypeFilters ------------->>>>', this.deliveryTypeFilters);
    },
    selectedItemdataEvent(selectedItems){
      this.finalSelectedItems = [];
      this.selectedItems = selectedItems;
      for (let i = 0; i < this.selectedItems.length; i++) {
        this.selectedShipments = this.selectedItems[i].ShippingID;
        this.selectedShipmentType = this.selectedItems[i].ShipmentType;

        let shippingid = this.selectedShipments;
        let shipmenttype = this.selectedShipmentType;

        this.selectedObj = {
          shippingid,
          shipmenttype
        }
        this.finalSelectedItems.push(this.selectedObj)
      }
      // console.log("finalSelectedItems",this.finalSelectedItems);
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    countDownChangedSuccess(dismissCountDownSuccess) {
      this.dismissCountDownSuccess = dismissCountDownSuccess
    },
    getHubName(hubid) {
      this.input = {
        hubids: [hubid]
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url + 'expose/hubservicecenter/hubarray/get',
          data: this.input
        })
        .then(result => {
          if (result.data.data.code == 200) {
            //console.log('Result hub',result.data);
            this.hubName = result.data.data.data[0].HubName
            this.latitude = result.data.data.data[0].Latitude
            this.longitude = result.data.data.data[0].Longitude
          } else {
            this.hubName = '';
          }
          this.inputHub = {
            "Outsourceid":4,
            "hubid":this.userHubId
          }
          axios({
            method: 'POST',
            url: apiUrl.api_url + 'expose/hubservicecenter/getHubFlags',
            data: this.inputHub
          })
          .then(result => {
            if (result.data.data.code==200) {
              this.isRSVSr = result.data.data.data.IsRSVSr
            } else {
              this.$alertify.error(result.data.data.message)
            }
          }, error => {
            console.error(error)
          })
        }, error => {
          console.error(error)
        })
    },

    //function for Route List...
    loadRouteList(hubid) {
      this.routeLoader = this.loader
      this.routeArrayList = []
      this.routeList = []
      this.routeListFlt = []
      this.SelectRoute = true

      if(hubid) {
        this.input = {
          // "usertype":"3",
        "currenthubid":hubid
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'locus/get/AllRoutemasterdetails',
          data: this.input
        })
        .then(result => {
          if (result.data.code == 200) {
            this.routeArrayList = result.data.data;
            // if(this.ActiveTabIndex == 1){
            //   this.routeList.push({
            //     value: 'CR',
            //     text: 'Create Route',
            //     status: 'New Route',
            //     deliveryType: 'NR',
            //   })
            // }

            for (var i = 0; i < this.routeArrayList.length; i++) {
              this.routeList.push({
                value: this.routeArrayList[i].routesmasterid,
                text: `${this.routeArrayList[i].routesmasterid} `,
                status: this.routeArrayList[i].rstatus,
                // deliveryType: this.routeArrayList[i].deliverytype,
                RouteName: this.routeArrayList[i].routename
              })
              this.routeListFlt.push({
                value: this.routeArrayList[i].routesmasterid,
                text: `${this.routeArrayList[i].routesmasterid} `,
                status: this.routeArrayList[i].rstatus,
                // deliveryType: this.routeArrayList[i].deliverytype
              })
            }
          } else {
            this.$alertify.error(result.data.message?result.data.message:'No Record found')
          }
          this.routeLoader = ''
        }, error => {
          this.routeLoader = ''
          console.error(error)
        })
      }
      else {
        this.$alertify.error("Current Hub Id not found.")
      }
    },

    ShowAssignedToSRList(){
      this.loadRouteList(this.userHubId);
      this.shipmentNo = '';
      this.Shipmentloader = true;
      this.AssignedToSRList = [];
      let payload = {
        hubid : this.userHubId,
      }

      if(this.PlannedRoutes == true){
        payload.isAssigned = true;
        this.UnassignedRoutes = false;
        this.selectedRoutedata = false;
        this.selectedRouteIds = [];
      }
      else if(this.UnassignedRoutes == true){
        payload.isAssigned = false;
        this.PlannedRoutes = false;
        this.selectedRoutedata = false;
        this.selectedRouteIds = [];
      }
      else if(this.PlannedRoutes == false || this.UnassignedRoutes == false){
        this.PlannedRoutes = false;
        this.UnassignedRoutes = false;
        this.selectedRoutedata = false;
        this.selectedRouteIds = [];
      }

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'locus/GetAvailableRoutes',
        data: payload
      })
      .then(result => {
        if (result.data.code==200) {
          this.AssignedToSRList = result.data.data;
        } else {
          this.$alertify.error(result.data.message?result.data.message:'No Record found')
        }
        this.Shipmentloader = false;
        this.getShipmentForMap();
      }, error => {
        console.error(error)
      })
    },

    //function for select route from list...
    selectRoute(obj){
      if(this.ActiveTabIndex == 2){
        this.searchByShippingId2 = '';
        this.routeItemObj = obj;
        this.routeId = obj.value
      }
      if(this.ActiveTabIndex == 2 && this.EditReAssignSRModel == true){
        this.routeItemObj3 = obj;
        this.routeId3 = obj.value
      }
      this.routeName = obj.text;
      if(this.ActiveTabIndex == 3){
        this.searchByShippingId3 = '';
        this.routeItemObj1 = obj;
        this.routeId1 = obj.value
      }
      if(this.ActiveTabIndex == 1){
        this.routeItemObj2 = obj;
        this.routeId2 = obj.value
      }
      this.buttonStatus = obj.status
      this.deliverytype = obj.deliveryType
      this.routename = obj.RouteName
      this.RouteHubName = this.hubName;
      this.IsSelectPlanned = true;
      if(this.ActiveTabIndex == 3){
        this.getAllocatedShipments()
      }
      if(this.ActiveTabIndex == 2 && this.routeId != ''){
        this.PLpageNo = 1;
        this.ShowPlannedUnplannedShipments()
      }
      if(this.ActiveTabIndex == 2 && this.routeId == ''){
        this.PLRTpageNo = 1;
        this.ShowPlannedUnplannedShipments()
      }
      // if(this.ActiveTabIndex == )
      // this.IsSelectRoute = true
    },

    selectReasonOption(obj){
      this.ReasonOptionItemObj = obj;
      this.ReasonOption = obj.value;
      this.Reason = obj.text;
    },

    //function for create route...
    CreateRoute() {
      this.Shipmentloader = true
      if(this.RouteName == ''){
        this.$alertify.error('Please Enter Correct Route Name.!');
      }
      // if(this.deliveryOption == '') {
      //   this.$alertify.error('Please select delivery option type !');
      // }
      else{
        let payload = {
          routename : this.RouteName,
          // deliverytype : this.deliveryOption,
          CreatedBy : this.createdBy,
          currenthubid : this.userHubId,
          hubname : this.hubName
        }
        axios.post(apiUrl.api_url + 'locus/create/route',payload)
        .then((response) => {
          if (response.data.code == 200){
            this.$alertify.success('Route Created Successfully.')
            this.clearTrip()
          }
          else{
            this.$alertify.error(response.data.message)
          }
          this.loadRouteList(this.userHubId)
          this.Shipmentloader = false
          this.isResetLoad = false
          this.RouteName= ''
        }, error => {
          console.error(error)
        })
      }
      this.Shipmentloader = false
    },

    resetRoute(){
      this.deliveryTypeFilters = '';
      this.deliveryTypeFilters1 = '';
      this.deliveryTypeFilters2 = '';
      this.RouteName= '',
      this.searchByShippingId = '';
      this.searchByShippingId1 = '';
      this.searchByShippingId2 = '';
      this.searchByShippingId3 = '';
      this.searchByShippingId4 = '';
      this.routeId = '',
      this.routeId1 = '',
      this.routeId2 = '',
      this.routeId3 = '',
      this.deliveryOptionItemObj = { text: ""}
      this.deliveryOption = ''
      this.buttonStatus = ''
      this.UnplannedTab = false,
      this.PlannedTab = false,
      this.isCreateRoute = false,
      this.isResetLoad = false
      this.Shipmentloader = false,
      this.EditReAssignSRModelLoader = false
      this.routeItemObj = { value: "",text: ""},
      this.routeItemObj1 = { value: "",text: ""},
      this.routeItemObj2 = { value: "",text: ""},
      this.routeItemObj3 = { value: "",text: ""},
      this.allocationErrorMsg = "",
      this.successAllocationCount = ""
      this.errorAllocationCount = ""
      this.IsReload = true;
      this.searchByShippingId = '';
      this.IsAllocateShip = false;
      this.isSequenceNo = false;
      this.PLpageNo = 1;
      this.PLpagecount = 0;
      this.PLRTpageNo = 1;
      this.PLRTpagecount = 0;
      this.UnPLpageNo = 1;
      this.UnPLpagecount = 0;
      this.selectedRouteIds = [];
      this.selectedRoutedata = false;

      if(this.ActiveTabIndex == 1 || this.ActiveTabIndex == 2){
        this.ShowPlannedUnplannedShipments()
      }
      if(this.ActiveTabIndex == 3){
        this.ClearSR()
        this.getAllocatedShipments()
      }
      this.errors.clear();
      this.$validator.reset();
    },

    ClearRouteNameDelOpt(){
      this.RouteName= '',
      this.deliveryOptionItemObj = { text: ""}
      this.deliveryOption = ''
    },

    //funtion for show allocated shipment list...
    getAllocatedShipments() {
      this.ShipmentCount = 0;
      this.shipmentNo = '';
      this.deliveryTypeFilters = '';
      this.deliveryTypeFilters1 = '';
      this.deliveryTypeFilters2 = '';
      this.loadRouteList(this.userHubId);
      this.routeId = '';
      this.routeItemObj = { value: "",text: ""},
      this.srId = '';
      this.srItemObj = { value: "",text: ""},
      this.PlannedMapView = false;
      this.ShowAssignedToSRShipmentModel = true;
      this.showShipmentsList = [];
      this.Shipmentloader = true;
      this.searchByShippingId = '';
      this.searchByShippingId1 = '';
      this.searchByShippingId2 = '';
      this.IsSelectPlanned = false;

      let payload = {
        HubID : this.userHubId,
        ShipmentType : this.filterShipmentType,
        limit:"10",
        pageNo:this.AllocatedpageNo.toString(),
      }

      if(this.srId1){
        payload.DeliveryUserID = this.srId1
      }

      if(this.routeId1){
        payload.RouteID = this.routeId1
      }

      if(this.searchByShippingId3) {
        payload.pageNo = '1';
        payload.ShippingID = this.searchByShippingId3
      }

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'locus/getallocatedshipments',
        data: payload
      })
      .then(result => {
        if (result.data.code==200) {
          this.showShipmentsList = result.data.data.rows;
          this.ShipmentCount = result.data.data.count;
          this.Allocatedpagecount = Math.ceil(this.ShipmentCount/this.PageLimit)
        }
        else {
          this.Allocatedpagecount = 1;
          this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
        }
        this.Shipmentloader = false;
        this.ShowAssignedToSRShipmentModel = false;
        this.searchByShippingId3 = '';
      }, error => {
        console.error(error)
      })
      // }
    },

    SearchAllocatedShipments(event){
      if(event.keyCode === 13) {
        this.getAllocatedShipments();
      }
    },

    SearchEligibledata(event){
      if(event.keyCode === 13) {
        this.ShowEligibleShipmentList();
      }
    },

    SearchPlannedUnPlanneddata(event){
      if(event.keyCode === 13) {
        this.ShowPlannedUnplannedShipments();
      }
    },

    reloadUnplannedData(){
      this.IsReload = true;
      // this.PsearchByShippingId = '';
      this.searchByShippingId1 = '';
      this.searchByShippingId2 = '';
      this.searchByShippingId4 = '';
      this.selectedItems = [];
      this.finalSelectedItems = [];
      this.ShowPlannedUnplannedShipments()
    },

    reloadAllocatedShipmentList(){
      // this.PsearchByShippingId = '';
      this.searchByShippingId3 = '';
      this.getAllocatedShipments()
    },

    ViewPlanData(){
      if(this.routeId == ''){
        this.$alertify.error("Please Select Route First.!")
        return false;
      }
      if(this.ActiveTabIndex == 2 && this.routeId){
        this.ShowPlannedUnplannedShipments()
      }
    },

    //funtion for show Unplanned and Planned shipment list...
    ShowPlannedUnplannedShipments() {
      this.ShipmentCount = 0;
      this.shipmentNo = '';
      this.deliveryTypeFilters = '';
      this.loadRouteList(this.userHubId)
      this.Shipmentloader = true;
      this.routeId1 = '';
      this.routeItemObj1 = { value: "",text: ""},
      this.srId1 = '';
      this.srItemObj1 = { value: "",text: ""},
      this.ShowUnplannedShipmentModel = true;
      this.Shipmentloader = true;
      this.showShipmentsList = [];
      this.searchByShippingId = ''
      this.searchByShippingId3 = '';
      this.isSequenceNo = false;
      this.PLpagecount = 0;
      this.UnPLpagecount = 0;
      this.PLRTpagecount = 0;
      this.selectedRouteIds = [];
      this.selectedRoutedata = false;

      let payload = {
        HubId : this.userHubId,
        limit:"10",
        ShipmentType : this.filterShipmentType
        // pageNo:this.PlUnPLpageNo.toString(),
      }

      if(this.ActiveTabIndex == 1){
        this.currentScreenTab = '';
        this.deliveryTypeFilters2 = '';
        payload.pageNo = this.UnPLpageNo.toString(),
        this.searchByShippingId2 = ''
        this.routeId = '';
        this.routeItemObj = { value: "",text: ""},
        // payload.IsPlanned = '0'
        this.ShowUnplannedShipmentModel = true
        this.IsSelectPlanned = false
        // this.PlannedTableColumns = []
      }
      if(this.ActiveTabIndex == 2 || this.currentScreenTab == 'listview'){
        this.deliveryTypeFilters1 = '';
        payload.pageNo = this.PLpageNo.toString(),
        this.searchByShippingId1 = ''
        this.currentScreenTab = 'listview'
        this.ShowPlannedShipmentModel = true
        payload.IsPlanned = '1'
        this.IsSelectPlanned = true
        // this.UnPlannedTableColumns = []
      }

      // if(this.ActiveTabIndex == 1 && this.deliveryTypeFilters1){
      //   payload.ShipmentType = this.deliveryTypeFilters1
      // }
      // else if(this.ActiveTabIndex == 2 && this.deliveryTypeFilters2){
      //   payload.ShipmentType = this.deliveryTypeFilters2
      // }
      // else{
      //   payload.ShipmentType = this.filterShipmentType
      // }

      if(this.routeId){
        this.isSequenceNo = true;
        payload.RouteId = this.routeId
      }

      if(this.searchByShippingId1 && this.ActiveTabIndex == 1){
        payload.pageNo = '1';
        payload.ShippingID = this.searchByShippingId1
      }

      if(this.searchByShippingId2 && this.ActiveTabIndex == 2) {
        payload.pageNo = '1';
        payload.ShippingID = this.searchByShippingId2
      }

      if(this.searchByShippingId4 && this.CreateAddRouteModel == true){
        payload.pageNo = '1';
        payload.ShippingID = this.searchByShippingId4;
      }

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'locus/get/planned/unplanned/shipment',
        data: payload
      })
      .then(result => {
        if (result.data.code==200 || typeof result == 'undefined') {
          this.showShipmentsList = result.data.data.rows;
          this.ShipmentCount = result.data.data.count;
          if(this.ActiveTabIndex == 1){
            this.UnPLpagecount = Math.ceil(this.ShipmentCount/this.PageLimit)
          }
          if(this.ActiveTabIndex == 2){
            this.PLpagecount = Math.ceil(this.ShipmentCount/this.PageLimit)
          }
          if(this.ActiveTabIndex == 2 && this.routeId != ''){
            this.PLRTpagecount = Math.ceil(this.ShipmentCount/this.PageLimit)
          }
        } else {
          this.UnPLpagecount = 1;
          this.PLpagecount = 1;
          this.PLRTpagecount = 1;
          this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
        }
        this.Shipmentloader = false;
        this.PlannedMapView = false;
        // this.deliveryTypeFilters = '';
        this.IsReload = false;
        this.ShowUnplannedShipmentModel = true;
        this.Shipmentloader = false;
        this.searchByShippingId1 = '';
        this.searchByShippingId2 = '';
      }, error => {
        console.error(error)
      })
    },

    //Function to get eligible shipments..
    ShowEligibleShipmentList(){
      this.ShipmentCount = 0;
      this.shipmentNo = '';
      this.deliveryTypeFilters1 = '';
      this.deliveryTypeFilters2 = '';
      this.loadRouteList(this.userHubId);
      this.routeId1 = '';
      this.routeItemObj1 = { value: "",text: ""},
      this.srId1 = '';
      this.srItemObj1 = { value: "",text: ""},
      this.ShowEligibleShipmentModel = true;
      this.Shipmentloader = true;
      this.showShipmentsList = [];
      this.searchByShippingId1 = '';
      this.searchByShippingId2 = '';
      this.searchByShippingId3 = '';
      this.selectedRouteIds = [];
      this.selectedRoutedata = false;

      let payload = {
        HubId : this.userHubId,
        limit:"10",
        pageNo:this.eligiblepageNo.toString(),
        ShipmentType : this.filterShipmentType
      }

      // if(this.deliveryTypeFilters){
      //   payload.ShipmentType = this.deliveryTypeFilters
      // }
      // else{
      //   payload.ShipmentType = this.filterShipmentType
      // }
      // if(this.filterShipmentType) {
      //   console.log("filterShipmentType",this.filterShipmentType)
      //   payload.ShipmentType = this.filterShipmentType
      // }

      if(this.searchByShippingId) {
        payload.pageNo = '1';
        payload.ShippingID = this.searchByShippingId;
      }

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'locus/retrieveEligibleShipments',
        data: payload
      })
      .then(result => {
        if (result.data.code==200 || typeof result == 'undefined') {
          this.showShipmentsList = result.data.data.rows;
          this.ShipmentCount = result.data.data.count;
          this.eligiblepagecount = Math.ceil(this.ShipmentCount/this.PageLimit)
        } else {
          this.eligiblepagecount = 1;
          this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
        }
        this.Shipmentloader = false;
        this.PlannedMapView = false;
        this.ShowEligibleShipmentModel = false;
        this.searchByShippingId = '';
        // this.deliveryTypeFilters = ''
      }, error => {
        console.error(error)
      })
    },

    getTablePaginationData(pageNum) {
      if(this.ActiveTabIndex == 0){
        this.eligiblepageNo = pageNum;
        this.ShowEligibleShipmentList();
      }
      if(this.ActiveTabIndex == 1){
        this.UnPLpageNo = pageNum;
        this.ShowPlannedUnplannedShipments();
      }
      if(this.ActiveTabIndex == 2){
        this.PLpageNo = pageNum;
        this.ShowPlannedUnplannedShipments();
      }
      if(this.ActiveTabIndex == 2 && this.routeId != ''){
        this.PLRTpageNo = pageNum;
        this.ShowPlannedUnplannedShipments();
      }
      if(this.ActiveTabIndex == 3){
        this.AllocatedpageNo = pageNum;
        this.getAllocatedShipments();
      }
    },

    CreateAddRoute(){
      this.CreateAddRouteModel = true;
      this.searchByShippingId = '';
      this.searchByShippingId1 = '';
      this.searchByShippingId2 = '';
      this.searchByShippingId3 = '';
      this.deliveryTypeFilters1 = '';
      this.ShowPlannedUnplannedShipments();
    },

    closeCreateAddRouteModel(){
      this.searchByShippingId4 = '';
      this.selectedItems = [];
      this.finalSelectedItems = [];
      this.IsReload = true;
      this.routeItemObj2 = { value: "",text: ""},
      this.routeId2 = '',
      this.CreateAddRouteModel = false;
      this.isCreateRoute = false;
      this.searchByShippingId = '';
      this.allocationErrorMsg = "";
      this.successAllocationCount = "",
      this.errorAllocationCount = "",
      this.IsAllocateShip = false;
      this.ShowPlannedUnplannedShipments();
    },

    ViewPlannedMap(){
      this.currentScreenTab = 'allocationview'
      this.PlannedMapView = true
      this.PlannedListView = false
      this.PlannedRoutes = false;
      this.UnassignedRoutes = false;
      this.getShipmentForMap();
    },

    ViewPlannedList(){
      this.currentScreenTab = 'listview'
      this.PlannedListView = true;
      this.PlannedMapView = false;
      this.selectedRouteIds = [];
      this.selectedRoutedata = false;
      this.ShowPlannedUnplannedShipments();
    },

    EditReAssignSR(routeid){
      this.EditReAssignSRModel = true;
      this.selectedRouteIds = [];
      this.selectedRoutedata = false;
      this.routeId3 = routeid;
      let obj = this.routeList.find(el=>{
        return el.value == routeid
      })
      if(this.ActiveTabIndex == 2 && this.currentScreenTab == 'allocationview'){
        this.routeItemObj3 = obj;
        this.routeId3 = routeid;
      }
      this.loadRouteList(this.userHubId);
    },

    MapRouteToSR(){
      this.EditReAssignSRModelLoader = true
      if(this.flagShowEbnVehicleNo == true){
        if(this.vehicleNoRegExp.test(this.ebnVehicleNo.toUpperCase())==false) {
          return this.errEbnVehicleNo = 'Enter Correct Vehicle No';
        }
      }
      this.errEbnVehicleNo = "";
      this.successAllocationCount = "",
      this.errorAllocationCount = "",
      this.allocationErrorMsg = ""
      this.allocationSuccessMsg = ""
      this.flagShowPreviousShipment = false
      var selectedSrDtl = this.srArrayList.filter(n=>{
        return n.userid==this.srId
      })
      this.input = {
        "XBkey":"XB123",
        "MarkedFrom":"Web",//this.fromId,
        "routeid" : this.routeId3,
        "HubId":this.userHubId.toString(),
        "EmpType":selectedSrDtl[0].EmpType?selectedSrDtl[0].EmpType:"",
        "MarkedFrom":"Web",//this.fromId,
        "DeliveryUserId":this.srId,
        "OldDeliveryUserOrUserId":selectedSrDtl[0].OldDeliveryUserOrUserId?selectedSrDtl[0].OldDeliveryUserOrUserId.toString():"0",
        "DeliveryUserName":this.srName,
        "LastModifiedBy":this.createdBy,
        // "AllocationType":this.routeArrayList[0].deliverytype,
        "MobileNo":selectedSrDtl[0].MobileNumber?selectedSrDtl[0].MobileNumber.toString():"",
        "isTripAllowedForSR": this.IsSRNeedTrip,
      }
      if(this.deliveryOption.toLowerCase() == 'dto') {
        this.input.IsRVPPaperless = this.IsRVPPaperless
      }

      if(this.IsLongPinCodeFlag != null) {
        this.input['IsLongPinCodeFlag'] = this.IsLongPinCodeFlag
      }

      if(this.serviceCatagoryOption){
        this.input.ServiceCategory = this.serviceCatagoryOption
      }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'locus/maproutetosr',
          data: this.input
        })
        .then(result => {
          this.IsConfirmAllocation = false;
          if (result.data.code==200) {
            this.isAllocation = true
            this.IsMaproute = true
            this.shipmentNo = '';
            // this.loadSrShipmentDetails()
            this.dismissCountDownSuccess = this.dismissSecs
            // this.allocationSuccessMsg = tempStr+" :- "+result.data.message
          if(result.data.data.Errors.length <=0){
            this.allocationSuccessMsg = result.data.message
            this.errorAllocationCount = result.data.data.Errors.length
            this.successAllocationCount = result.data.data.Success
          }
          else if(result.data.data.Errors != null){
            this.allocationErrorMsg = result.data.data.Errors
            this.errorAllocationCount = result.data.data.Errors.length
            this.successAllocationCount = result.data.data.Success
          }
          this.EditReAssignSRModelLoader = false

          this.flagShowEbnVehicleNo = false;

          //tracker api called here
          let TrackerInfo = {
            projectname:"Last Mile",
            type:"Web",
            userid:this.userid,
            username:this.createdBy,
            meta: {
              "event":"shipmentallocation",
              // "shipment": tempStr,
              "allocationtype": this.deliveryOption,
              "srid": this.srId
            }
          }
          this.PageTracker(TrackerInfo);
          //end

        }
        else{
          this.IsMaproute = false;
          this.$alertify.error(result.data.message)
        }
        this.ShowAssignedToSRList();
        // this.ShowPlannedUnplannedShipments()
        // else {
        //   this.ebnVehicleNo = '';
        //   this.flagShowEbnVehicleNo = false;
        //   if(typeof result.data.status !=undefined && result.data.status==204) {
        //     this.flagShowPreviousShipment = true
        //   }
        //   if (typeof result.data.status !=undefined && result.data.status==205) {
        //     this.ReAttemptAllocation(result);
        //   }
        //   if(typeof result.data.status !=undefined && result.data.status==207) {
        //     this.flagShowEbnVehicleNo = true;
        //      this.$refs.ebnVehicleNo.focus();
        //   }
        //   if (typeof result.data.status !=undefined && result.data.status==209) {
        //     this.ReAttemptLongPincodeAllocation(result);
        //   }

        //   this.dismissCountDown = this.dismissSecs
        //   this.allocationErrorMsg = result.data.message!='' && result.data.message!=undefined?result.data.message : 'Not getting any response message.'
        // }
        this.IsLongPinCodeFlag = null;
        this.EditReAssignSRModelLoader = false
      }, error => {
        this.EditReAssignSRModelLoader = false
        console.error(error)
      })
    },

    closeReAssignedSRModel(){
      this.allocationSuccessMsg = "",
      this.allocationErrorMsg = "",
      this.errorAllocationCount = "",
      this.successAllocationCount = "",
      this.IsSelectPlanned = true
      this.PlannedListView = false
      this.PlannedMapView = true
      this.resetTrip();
      this.EditReAssignSRModel = false;
      this.routeId3 = '';
      this.routeId = '';
      this.IsMaproute = false;
      this.selectedRouteIds = [];
      this.selectedRoutedata = false;
      this.currentScreenTab = 'allocationview'
    },

    closeRemoveShipmentModal(){
      this.ReasonOption = '';
      this.ReasonOptionItemObj = '';
      this.RemoveShipmentModal = false;
    },

    closeEditSequenceNoModal(){
      this.SequenceNo = ''
      this.EditSequenceNoModal = false;
    },

    EditRouteShipments(routeid){
      this.PlannedListView = true;
      this.routeId = routeid;
      this.PlannedMapView = false
      let obj = this.routeList.find(el=>{
        return el.value == routeid
      })
      if(this.ActiveTabIndex == 2){
        this.routeItemObj = obj;
        this.routeId = routeid;
        this.ShowPlannedUnplannedShipments()
      }
    },

    //function for close & reopen the route...
    closeReopenRoute(){
      this.isResetLoad = true

      let payload = {
        routename : this.routename,
        routesmasterID : this.routeId,
        deliverytype : this.deliverytype,
        currenthubid : this.userHubId,
        hubname : this.hubName
      }
      if(this.buttonStatus=='inprocess'){
        payload.actionType = 'closed'
      }
      if(this.buttonStatus=='closed'){
        payload.actionType = 'inprocess'
      }

      axios.post(apiUrl.api_url + 'locus/close/reopen/route',payload)
      .then((response) => {
        if (response.data.code == 200){
          this.$alertify.success(response.data.message)
          this.clearTrip()
        }
        else{
          this.$alertify.error(response.data.message)
        }
        this.isResetLoad = false
        this.buttonStatus = ''
      }, error => {
        console.error(error)
      })
    },

    //function for allocate shipment to route...
    // AllocateRoute(){
    //   this.Shipmentloader = true

    //   let payload = {
    //     HubId : this.userHubId.toString(),
    //     ShippingID : (this.shipmentNo).trim(),
    //     AllocationType : this.deliverytype,
    //     routeid : this.routeId,
    //     LastModifiedBy : this.createdBy
    //   }
    //   // if(CourierCompanyID){
    //   //   payload.CourierCompanyID = selectedSrDtl[0].CourierCompanyID?selectedSrDtl[0].CourierCompanyID.toString():'null'
    //   // }

    //   axios.post(apiUrl.api_url + 'expose/allocate/route',payload)
    //   .then((response) => {
    //     if (response.data.code == 200){
    //       this.shipmentNo = '';
    //       this.$refs.shipmentNo.focus()
    //       this.$alertify.success(response.data.message)
    //     }
    //     else{
    //       this.$alertify.error(response.data.message)
    //     }
    //     this.Shipmentloader = false
    //   }, error => {
    //     console.error(error)
    //   })
    // },

    //Allocate Shipments to route function..
    AllocateShipmentsToRoute(){
      this.isCreateRoute = false,
      this.Shipmentloader = true,
      this.IsReload = true;
      this.allocationErrorMsg = ""
      this.allocationSuccessMsg = ""

      if(this.routeItemObj2.value == ''){
        this.$alertify.error("Please Select Route First.!!")
        this.Shipmentloader = false
        return false;
      }
      else if(this.selectedItems.length <= 0){
        this.$alertify.error("Please Select At Least One Shipmnet.!!")
        this.Shipmentloader = false
        return false;
      }
      let Payload = {
        HubId : this.userHubId.toString(),
        // ShippingIDs : this.selectedItems.ShippingID,
        // AllocationType : this.selectedItems.ShipmentType,
        shippinginfo: this.finalSelectedItems,
        routeid : this.routeId2,
        LastModifiedBy : this.createdBy
      }
      // console.log("this.routeId",this.routeId)
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'locus/allocate/shipment/to/route',
        data: Payload
      })
      .then((response) => {
        if (response.data.code == 200 && response.data.data.Errors.length <=0){
          this.IsAllocateShip = true;
          this.dismissCountDown = this.dismissSecs;
          this.allocationSuccessMsg = this.$alertify.success(response.data.message);
          this.successAllocationCount = this.finalSelectedItems.length - response.data.data.Errors.length;
          // console.log("successAllocationCount",this.successAllocationCount)
        }
        else if(response.data.code == 200 && response.data.data.Errors != null){
          this.IsAllocateShip = true;
          this.dismissCountDown = this.dismissSecs
          this.allocationErrorMsg = response.data.data.Errors;
          this.errorAllocationCount = response.data.data.Errors.length;
          this.successAllocationCount = this.finalSelectedItems.length - response.data.data.Errors.length;
          // console.log("successAllocationCount",this.successAllocationCount)
        }
        else{
          this.$alertify.error(response.data.message)
        }
        this.finalSelectedItems = [];
        this.Shipmentloader = false;
        this.ShowPlannedUnplannedShipments();
        this.ShowAssignedToSRList();
        this.IsReload = false;
      }, error => {
        console.error(error)
      })
      this.resetRoute();
    },

    //function for get shippingId and routeid for remove shipment from Route.
    removeShipmentFromRoute(shippingId,routeId) {
      this.RemoveShipmentModal = true;
      this.RemoveShipingId = shippingId,
      this.RemoveRouteId = routeId
    },

    //function for remove shipment from Route.
    removeRouteShipment(){
      if(this.RemoveShipingId){
        this.input = {
          "routeid": this.RemoveRouteId,
          "ShippingId": this.RemoveShipingId,
          "LastModifiedBy": this.createdBy,
          "reason": this.Reason
          // "shipmenttype": this.deliverytype,
        }

        if(this.ActiveTabIndex == 3){
          this.input.isSRAssigned = true;
        }

        axios({
          method: 'POST',
          url: apiUrl.api_url + 'locus/remove/shipment/from/route',
          data: this.input
        })
        .then(result => {
          if (result.data.code==200) {
            this.$alertify.success("Shipment Removed Successfully.!")
            if(this.ActiveTabIndex == 2){
              this.ShowPlannedUnplannedShipments()
            }
            if(this.ActiveTabIndex == 3){
              this.getAllocatedShipments()
            }
          } else {
            this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
          }
          this.ReasonOption = '';
          this.ReasonOptionItemObj = '';
          this.RouteShipmentloader = false
        }, error => {
          this.RouteShipmentloader = false
          console.error(error)
        })
        this.ReasonOption = '';
        this.ReasonOptionItemObj = '';
        this.RemoveShipmentModal = false;
      }
      else{
        this.$alertify.error("Shipment ID not found")
      }
      this.resetRoute();
    },

    //function to get shipment details for map view
    getShipmentForMap(){
      this.PolyLines = [];
      this.Markers = [];

      let payload = {
        HubId: this.userHubId,
      }

      if(this.selectedRouteIds != ''){
        payload.RouteId = this.selectedRouteIds
      }

      if(this.PlannedRoutes == true){
        payload.isPlanned = true;
        this.UnassignedRoutes = false;
      }
      if(this.UnassignedRoutes == true){
        payload.isPlanned = false;
        this.PlannedRoutes = false;
      }

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'routeplanner/getroutesshipments',
        data: payload
      })
      .then(result => {
        if (result.data.code==200) {
          let resultLength = result.data.data.length;
          let Result = result.data.data;
          for (let i = 0; i < resultLength; i++) {
            if(Result[i] != null){
              let ShipObjLen = Result[i].length;
              let routeShips = [];
              let Shipments = Result[i];
              // let PolyLatLong = {};
              let PolyRoute = null;
              let PolyPoints = [];

              for(let k = 0; k < ShipObjLen; k++){
                let DropLatitude = Shipments[k].DropLatitude;
                let DropLongitude = Shipments[k].DropLongitude;
                let CustAddress = Shipments[k].CustomerAddress;
                // let MCustAddr = CustAddress.replaceAll(',' , ', \n')
                // // CustAddress.split(",").join(", \n");              
                // console.log("CustAddress mmmmm",MCustAddr);
                let LatLong = null;
                let lat = null;
                let long = null;
                PolyRoute = Shipments[k].routeid;

                if(DropLatitude != null && DropLongitude !=null){
                  //LatLong = eval(L.latLng+'('+DropLatitude +' , '+ DropLongitude+')');
                  LatLong =  eval(L.latLng(DropLatitude, DropLongitude));
                  PolyPoints.push({"lat": DropLatitude, "lng": DropLongitude});
                }
                
                let ShipmentObj = {};
                ShipmentObj.SeqNo = Shipments[k].sequenceno;
                ShipmentObj.routeid = Shipments[k].routeid;
                ShipmentObj.latlng = LatLong;
                // ShipmentObj.latlng = L.latLng(LatLong);
                ShipmentObj.ShippingID = Shipments[k].ShippingID;
                ShipmentObj.Address = CustAddress;
                routeShips.push(ShipmentObj);
              }
 
              let ShipObj = {};
              ShipObj.markers = routeShips
              this.Markers.push(ShipObj);

              let PolyLineObj = {};
              PolyLineObj.routeid = PolyRoute;
              PolyLineObj.points = PolyPoints;
              PolyLineObj.visible = true;
              PolyLineObj.color = "#" + ((1<<24)*Math.random() | 0).toString(16)
              this.PolyLines.push(PolyLineObj);
            }
          }
          // console.log("PolyLines >>>>>>>>>>>>>>>>>",JSON.stringify(this.PolyLines));
          // console.log("Markers >>>>>>>>>>>>>>>>",JSON.stringify(this.Markers));

          // this.$alertify.success(result.data.message)
        }
        // else{
        //   this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
        // }
      })
    },

    //function for checkall...
    selectItems(ev) {
      this.selectedRouteIds = [];
      if (ev.target.checked == true) {
        for (let i in this.AssignedToSRList) {
          this.selectedRouteIds.push(this.AssignedToSRList[i].routesmasterid);
        }
        this.getShipmentForMap()
      }
      else{
        for (let i in this.AssignedToSRList) {
          this.selectedRouteIds.pop(this.AssignedToSRList[i].routesmasterid);
        }
        this.getShipmentForMap()
      }
    },

    //function to check for particular route...
    setcheckbox($event,routeid) {
      if ($event.target.checked == true) {
        if(!this.selectedRouteIds.includes(routeid)){
          this.selectedRouteIds.push(routeid);
        }
        this.getShipmentForMap()
      }
      else{
        if(this.selectedRouteIds.includes(routeid)){
          this.selectedRouteIds.pop(routeid);
        }
        this.getShipmentForMap()
      }
      if(this.selectedRouteIds.length == 0){
        this.selectedRoutedata = false
      }
      if(this.selectedRouteIds.length != this.AssignedToSRList.length){
        this.selectedRoutedata = false;
      }
      if(this.selectedRouteIds.length == this.AssignedToSRList.length){
        this.selectedRoutedata = true;
      }
    },

    editSequenceNo(shippingId){
      this.EditSequenceNoModal = true;
      this.SequenceNoShipment = shippingId;
    },

    //Function to edit Sequence No...
    EditSequenceNo(){
      if(this.SequenceNoShipment){
        let payload = {
          "ShippingId": this.SequenceNoShipment,
          "HubId": this.userHubId,
          "SequenceNo": this.SequenceNo,
          "LastModifiedBy": this.createdBy
        }
  
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'routeplanner/updatesequenceno',
          data: payload
        })
        .then(result => {
          if (result.data.code==200) {
            this.$alertify.success(result.data.message)
          }
          else{
            this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
          }
        })
        this.ShowPlannedUnplannedShipments();
        this.SequenceNo = '';
        this.EditSequenceNoModal = false;
      }
      else{
        this.$alertify.error("Data not found")
      }
    },

    //function for confirm plan button...
    confirmPlan(){
      if(this.routeId == ''){
        this.$alertify.error("Please Select Route First.!")
        return false;
      }

      let payload = {
        "RouteId": this.routeId,
      }

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'routeplanner/confirmplan',
        data: payload
      })
      .then(result => {
        if (result.data.code==200) {
          this.$alertify.success(result.data.message)
        }
        else{
          this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
        }
      })
    },

    ClearSR(){
      this.srId = '';
      this.srId1 = '';
      this.srName = '';
      this.srItemObj = { value: "",text: ""};
      this.srItemObj1 = { value: "",text: ""};
      // this.IsSelectPlanned = true
      this.srShipmentList = '';
    },

    loadSRList(hubid) {
      this.srLoader = this.loader
      this.srArrayList = []
      this.srList = []
      this.srListFlt = []
      if(hubid) {
        this.input = {
          "usertype":"3",
        "hubid":[hubid]
        }
        let apiendpoint = 'expose/users/HubDeliveryUsers/get/List';
        if (keycloak.enableKavach) {
            apiendpoint = 'user/migration/gethubdeliveryuserlist';
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + apiendpoint,
          data: this.input
        })
        .then(result => {
          //console.log('result.data',result.data.data.);
          if (result.data.data.code == 200) {
            this.srArrayList = result.data.data.results;
            for (var i = 0; i < this.srArrayList.length; i++) {
              this.srList.push({
                value: this.srArrayList[i].userid,
                text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`
              })
              this.srListFlt.push({
                value: this.srArrayList[i].userid,
                text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`
              })
            }
            //console.log('this.srList',this.srList);
          } else {
            this.$alertify.error(result.data.data.message?result.data.data.message:'No Record found')
          }
          this.srLoader = ''
        }, error => {
          this.srLoader = ''
          console.error(error)
        })
      } else {
        this.$alertify.error("Current Hub Id not found.")
      }
    },

    selectSR(obj) {
      // this.ActiveTabIndex = 0;
      this.isVehicleReplacedCheck = 0
      this.isVehicleReplaced=false
      this.fieldErr = false
      this.startTripFlag = false
      this.deliveryOptionItemObj = { text: ""}
      this.deliveryOption = ""
      //this.pendingShipmentList = []
      //this.totalPendingShipment = 0
      this.srItemObj = obj
      this.srId = obj.value
      if(this.ActiveTabIndex == 3){
        this.searchByShippingId3 = '';
        this.srItemObj1 = obj;
        this.srId1 = obj.value;
      }
      this.srName = obj.text
      this.vehicleTypeFlag = false
      this.flagShowEbnVehicleNo = false;
      this.ebnVehicleNo = '';
      this.shipmentNo = '';
      // this.IsSelectRoute = false
      if(this.ActiveTabIndex == 3){
        this.getAllocatedShipments()
      }

      var selectedSrDtl = this.srArrayList.filter(n=>{
        return n.userid==this.srId
      })
      //console.log('selectedSrDtl',selectedSrDtl);
      if(selectedSrDtl[0].EmpType==null || selectedSrDtl[0].EmpType=="") {
        this.fieldErr = true
        this.$alertify.error("EmpType not found against this SR, EmpType is required.")
        return false;
      } else {
        if(selectedSrDtl[0].isTripAllowedForSR == true) {
          this.IsSRNeedTrip = selectedSrDtl[0].isTripAllowedForSR;
          this.vehicleType = ""
          this.srVehicleList = []
          this.vehicleNoItemObj = {value:'', text: ''}
          this.vehicleOpenKM = ''
          this.vehicleNo = ''
          this.vehicleVendorId = 0
          this.startAllocationFlag = false
          this.tripTitle = 'Start Trip'
          this.errorCloseKM = ''
          this.errorOpenKM = ''
          this.closeKm = ''

          this.tripState= ''
          this.srShipmentList = []
          this.input = {
            "XBkey":"XB123",
          "HubId":this.userHubId,
          "DeliveryUserId":this.srId
          }
          axios({
            method: 'POST',
            url: apiUrl.api_url + 'expose/trip/tripDetails',
            data: this.input
          })
          .then(result => {
            if (result.data.TripState=="closed") {
              this.tripState='created'
              this.startTripFlag = true
              this.$alertify.error(result.data.message)
              this.tripDayflag = 0;
              this.tripDateFlag = false;
            } else if(result.data.TripState=="created" || result.data.TripState=="start") {
              this.tripCreatedDate = moment(result.data.TripCreatedDateTime).format('DD-MM-YYYY');
              this.currentDateTime = moment(result.data.CurrentDateTime).format('DD-MM-YYYY');
              if(this.tripCreatedDate == this.currentDateTime){
                //console.log('flag true');
                this.tripDayflag = 0;
                this.tripDateFlag = false;
              } else {
                this.tripDayflag = result.data.tripDayflag
                this.tripDateFlag = true;
              }
              this.tripState=result.data.TripState
              this.startTripFlag = true
              this.tripTitle = "Continue with existing trip"
              this.$alertify.error(result.data.message)
            } else if (result.data.TripState=="deliveryuserclosed" && result.data.code==200 ) {
              this.openKM = result.data.OpenKM
              this.openKmImg = result.data.OpenKMImageUrl
              this.closeKmImg = result.data.CloseKMImagUrl
              this.originCloseImg = result.data.CloseKMImagUrl
              this.tripId = result.data.TripId
              this.srVehicleNo = result.data.VehicleNo
              this.openKm = result.data.OpenKM
              this.closeTripModel = true
            } else {
              this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message')
            }

          }, error => {
            console.error(error)
          })
        } else {
         this.IsSRNeedTrip = selectedSrDtl[0].isTripAllowedForSR;
         this.srHubName = this.hubName;
         //this.loadSrShipmentDetails();
         this.tripCreatedDate = '';
         this.tripDayflag = 0;
         this.tripDateFlag = false;
         //this.$alertify.error('For selected SR not need to generate trip');
       }
      }
    },

    startTrip() {
      this.errVehicleNo = ""
      this.errVehicleKm = ""
      if(this.tripTitle=='Start Trip') {
        this.vehicleTypeFlag = true
      } else {
        this.startAllocation(false)
      }
    },
    loadVehicleDetails(type) {
      this.isVehicleReplacedCheck = 0
      this.isVehicleReplaced=false
      this.errVehicleNo = ""
      this.errVehicleKm = ""
      this.startAllocationFlag = false
      this.vehicleType = type
      this.srVehicleList = []
      this.vehicleNoItemObj = {value:'', text: ''}
      this.vehicleOpenKM = ''
      this.vehicleNo = ''
      this.vehicleVendorId = 0
      this.deliveryOptionItemObj = { text: ""}
      this.deliveryOption = ""
      if(type=="bike") {
        this.input = {
          "srid":this.srId,
          "hubid":this.userHubId
        }
        var url = apiUrl.api_url + "expose/getsrmapping"
      } else {
        this.input = {
          "HubId":this.userHubId
        }
        var url = apiUrl.api_url + "expose/GetVendorVehiclesForLastMile"
      }
      axios({
        method: 'POST',
        url: url,
        data: this.input
      })
      .then(result => {

        if (result.data.data.ResultCode==100) {
          if(type=="vehicle") {
            var srVehicleList = result.data.data.Data
            //console.log('srVehicleList',srVehicleList);
            for (var i = 0; i < srVehicleList.length; i++) {
              this.srVehicleList.push({value:srVehicleList[i].VendorVehicleId,text:srVehicleList[i].VehicleNumber})
            }
          } else {
            var srVehicleList = result.data.data.data
            for (var i = 0; i < srVehicleList.length; i++) {
              this.srVehicleList.push({value:srVehicleList[i].VehicleNumber,text:srVehicleList[i].VehicleNumber})
            }
          }

        } else {
          if(type=="vehicle") {
            this.$alertify.error("No record found.")
          }
        }
      }, error => {
        console.error(error)
      })
    },
    selectVehicleNo(obj) {
      this.vehicleNoItemObj = obj
      this.vehicleNo = obj.text
      this.vehicleVendorId = obj.value
    },
    startAllocation(flag) {
      //console.log('flagg',flag);
      this.flagShowPreviousShipment = false
      this.startAllocationFlag = false
      this.errVehicleNo = ""
      this.errVehicleKm = ""
      var decimal=  /^\d+(\d{1,2})?$/;

      if(decimal.test(this.vehicleOpenKM)==false && this.vehicleNoRegExp.test(this.vehicleNo.toUpperCase())==false && flag && this.vehicleVendorId==0) {
          this.errVehicleNo = "Enter Correct Vehicle No"
          this.errVehicleKm = "Enter Correct KM"
      } else if(this.vehicleNoRegExp.test(this.vehicleNo.toUpperCase())==false && flag && this.vehicleVendorId==0) {
          this.errVehicleNo = "Enter Correct Vehicle No"
      } else if(decimal.test(this.vehicleOpenKM)==false && flag) {
          this.errVehicleKm = "Enter Correct KM"
      } else if( flag && this.vehicleOpenKM > 1000000) {
          this.errVehicleKm = "Open Km should be less than 1000000"
      } else {
        this.clientOptionItemObj = {value: "",text: ""}
        this.clientOption = ""
        this.shipmentNo = ''

        this.srName = this.srItemObj.text
        this.srHubName = this.hubName
        this.routeName = this.routeItemObj.text
        this.startAllocationFlag = true
        this.input = {
          "XBkey":"XB123"
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'expose/client/dropdown/list',
          data: this.input
        })
        .then(result => {
          if (result.data.code==200) {
            var clientOptionList = result.data.data
            for (var i = 0; i < clientOptionList.length; i++) {
              this.clientOptionList.push({value:clientOptionList[i].ClientMasterID,text:clientOptionList[i].CompanyName})
            }
          }
        }, error => {
          console.error(error)
        })
        if(flag){
          this.TripCreation();
        } else {
          this.deliveryOptionItemObj = { text: ""}
          this.deliveryOption = ""
        }
      }
    },
    TripCreation(){
      this.allocationLoader = true;
      let formData = {
        "XBkey":"XB123",
        "sruserid":this.srId.toString(),
        "hubid":this.userHubId,
        "km":this.vehicleOpenKM?this.vehicleOpenKM:0,
        "tripstate":this.tripState,//"created",
        "vehicleno":this.vehicleNo.toUpperCase(),
        "vehicletype":this.vehicleType,
        "triptype":"Delivery",
        "srname":this.srName,
        "isvehiclereplaced":this.isVehicleReplaced,
        "operationType":"lastmile"
      }
      if((this.vehicleType=='bike' && this.srVehicleList.length==0) || this.isVehicleReplaced==true) {
        formData['isvehicleupdated'] = true
      } else {
        formData['isvehicleupdated'] = false
      }
      if(this.vehicleType=='vehicle') {
        formData['vehiclevendorid'] = this.vehicleVendorId
      }
      //console.log('formData',formData);

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'expose/trip/create',
        data: formData
      })
      .then(result => {

        if (result.data.code==200) {
          this.startAllocationFlag = true;
          this.$alertify.success(result.data.message);
          if(this.deliveryOption=="RVP") {
            if(this.tripTitle == 'Start Trip'){
              this.isAllocationRvp = false;
              this.rvpShipmentsModel = true;
              this.pickupItem = {value:'Pending',text:'All Pending'}
              this.fltpickup = 'Pending'
              this.fromToDate = ""
              this.pickupList = []
              this.tabIndex  = 0;
              this.showPendingPickups();
            }
          }

        } else if(result.data.code == 202) {
          this.startAllocationFlag = false;
          this.$alertify.error(result.data.message.details[0].message);
        } else {
          this.startAllocationFlag = false;
          this.$alertify.error(result.data.message);
        }
        this.allocationLoader = false;
      }, error => {
        this.startAllocationFlag = false;
        this.$alertify.error('Failed to Create Trip, Please retry!');
        this.allocationLoader = false;
        console.error(error)
      })
    },
    // isFlyerBarcodecheck(isPaperlessFlag,deliveryTpe){
    //   if( (isPaperlessFlag == true) && (deliveryTpe.toLowerCase() == 'rvp' || deliveryTpe.toLowerCase() == 'dto')) {
    //     this.IsPaperlessFlyerbarcode = this.IsRVPPaperless
    //   } else {
    //     this.IsPaperlessFlyerbarcode = false;
    //   }
    // },
    // selectDeliveryOption(obj) {
    //   this.flagShowPreviousShipment = false
    //   this.clientOptionItemObj = {value: "",text: ""}
    //   this.clientOption = ""
    //   this.serviceCatagoryOption = ""
    //   this.serviceCatagoryObj = {value: "",text: ""}
    //   this.deliveryOptionItemObj = obj
    //   this.deliveryOption = obj.text

    //   this.isFlyerBarcodecheck(this.IsRVPPaperless,this.deliveryOption);

    //   //this.loadSrShipmentDetails('reload');

    //   if(this.deliveryOption=="RVP") {
    //     //console.log('rvp test',this.IsSRNeedTrip,this.tripTitle);

    //     if( !this.IsSRNeedTrip || this.tripTitle != 'Start Trip') {
    //       this.rvpShipmentsModel = true;
    //     }
    //     this.isAllocationRvp = false;
    //     this.pickupItem = {value:'Pending',text:'All Pending'}
    //     this.fltpickup = 'Pending'
    //     this.fromToDate = ""
    //     this.pickupList = []
    //     this.tabIndex  = 0;
    //     this.showPendingPickups();
    //     //console.log('this.tripTitle ',this.tripTitle );
    //     //this.loadRVPAllocatedShipmentList()
    //   } else {
    //     this.loadPendingShipmentList('reload');
    //   }
    // },
    // selectServiceType(obj) {
    //   this.serviceCatagoryObj = obj
    //   this.serviceCatagoryOption = obj.value
    //   this.loadPendingShipmentList('reload');
    // },
    // selectClient(obj) {
    //   this.flagShowPreviousShipment = false
    //   this.clientOptionItemObj = obj
    //   this.clientOption = obj.value
    // },
    selectFrom(obj) {
      this.fromItemObj = obj
      this.fromId = obj.value
    },

    // allocation() {
    //   if(this.flagShowEbnVehicleNo == true){
    //     if(this.vehicleNoRegExp.test(this.ebnVehicleNo.toUpperCase())==false) {
    //       return this.errEbnVehicleNo = 'Enter Correct Vehicle No';
    //     }
    //   }
    //   this.errEbnVehicleNo = "";
    //   this.allocationErrorMsg = ""
    //   this.allocationSuccessMsg = ""
    //   this.isLoadingAlc = true
    //   this.flagShowPreviousShipment = false
    //   var tempStr = this.shipmentNo
    //   var selectedSrDtl = this.srArrayList.filter(n=>{
    //     return n.userid==this.srId
    //   })
    //   this.input = {
    //     "XBkey":"XB123",
    //   "HubId":this.userHubId.toString(),
    //   "DeliveryUserId":this.srId,
    //   "OldDeliveryUserOrUserId":selectedSrDtl[0].OldDeliveryUserOrUserId?selectedSrDtl[0].OldDeliveryUserOrUserId.toString():"0",
    //   "DeliveryUserName":this.srName,
    //   "ShippingID":(this.shipmentNo).trim(),
    //   "LastModifiedBy":this.createdBy,
    //   "IsConfirmAllocation":this.IsConfirmAllocation,
    //   "AllocationType":this.deliveryOption,
    //     "EmpType":selectedSrDtl[0].EmpType?selectedSrDtl[0].EmpType:"",
    //   "MarkedFrom":"Web",//this.fromId,
    //   "CourierCompanyID":selectedSrDtl[0].CourierCompanyID?selectedSrDtl[0].CourierCompanyID.toString():'null',
    //   "IsRSVCSr":this.isRSVSr,
    //   "MobileNo":selectedSrDtl[0].MobileNumber?selectedSrDtl[0].MobileNumber.toString():"",
    //     "isTripAllowedForSR": this.IsSRNeedTrip,
    //     "vehicleno": this.ebnVehicleNo

    //   }
    //   if(this.deliveryOption.toLowerCase() == 'dto') {
    //     this.input.IsRVPPaperless = this.IsRVPPaperless
    //   }

    //   if(this.IsLongPinCodeFlag != null) {
    //     this.input['IsLongPinCodeFlag'] = this.IsLongPinCodeFlag
    //   }

    //   if(this.serviceCatagoryOption){
    //     this.input.ServiceCategory = this.serviceCatagoryOption
    //   }
    //   //this.shipmentNo = ''
    //   axios({
    //     method: 'POST',
    //     url: apiUrl.api_url + 'expose/shipment/allocate',
    //     data: this.input
    //   })
    //   .then(result => {
    //     this.IsConfirmAllocation = false;
    //     if (result.data.code==200) {
    //       this.isAllocation = true
    //       this.shipmentNo = '';
    //       this.loadSrShipmentDetails()
    //       this.$refs.shipmentNo.focus()
    //       this.dismissCountDownSuccess = this.dismissSecs
    //       this.allocationSuccessMsg = tempStr+" :- "+result.data.message
    //       this.flagShowEbnVehicleNo = false;

    //       //tracker api called here
    //       let TrackerInfo = {
    //           projectname:"Last Mile",
    //           type:"Web",
    //           userid:this.userid,
    //           username:this.createdBy,
    //           meta: {
    //               "event":"shipmentallocation",
    //               "shipment": tempStr,
    //               "allocationtype": this.deliveryOption,
    //               "srid": this.srId
    //           }
    //       }
    //       this.PageTracker(TrackerInfo);
    //       //end

    //     } else {
    //       this.ebnVehicleNo = '';
    //       this.flagShowEbnVehicleNo = false;
    //       if(typeof result.data.status !=undefined && result.data.status==204) {
    //         this.flagShowPreviousShipment = true
    //       }
    //       if (typeof result.data.status !=undefined && result.data.status==205) {
    //         this.ReAttemptAllocation(result);
    //       }
    //       this.$refs.shipmentNo.focus();
    //       //this.shipmentNo = tempStr;
    //       //this.shipmentNo = '';
    //       if(typeof result.data.status !=undefined && result.data.status==207) {
    //         this.flagShowEbnVehicleNo = true;
    //           this.shipmentNo =   tempStr;
    //         this.$refs.ebnVehicleNo.focus();
    //       }
    //       if (typeof result.data.status !=undefined && result.data.status==209) {
    //         this.ReAttemptLongPincodeAllocation(result);
    //       } else {
    //         this.shipmentNo = '';
    //       }
    //       this.dismissCountDown = this.dismissSecs
    //       this.allocationErrorMsg = result.data.message!='' && result.data.message!=undefined?`${tempStr} :-  ${result.data.message}`: `${tempStr} :- Not getting any response message.`
    //     }
    //     this.IsLongPinCodeFlag = null;
    //     this.isLoadingAlc = false
    //   }, error => {
    //     this.shipmentNo = tempStr
    //     this.isLoadingAlc = false
    //     console.error(error)
    //   })
    // },

    // ReAttemptLongPincodeAllocation(getResult){
    //   let message = {
    //     title: '',
    //     body: `<p><b>${getResult.data.message}</b></p>  <p style="color:green">Click <b> YES</b> to Attempt Delivery. <br/> <span style="color:red"> Press <b> No </b> to Hold the Shipment.</span> </p>`,
    //   }

    //   let res = this.$dialog.confirm(message, {
    //     html: true,
    //     animation: 'bounce',
    //     backdropClose: false,
    //     okText: 'Yes',
    //     cancelText: 'No',
    //     reverse: true
    //     //loader: true
    //   })
    //   .then(dialog => {
    //     this.IsLongPinCodeFlag = true;
    //     this.allocation();
    //   })
    //   .catch((e) => {
    //     this.IsLongPinCodeFlag = false;
    //     this.allocation();
    //   })
    // },
    // ReAttemptAllocation(getResult){
    //   let message = {
    //     title: '',
    //     body: `<p><b>${getResult.data.message}</b></p>  <p style="color:green">Click <b> YES</b> to reattempt delivery. <br/> <span style="color:red"> Press <b> No </b> for Customer support working.</span> </p>`,
    //   }

    //   let res = this.$dialog.confirm(message, {
    //     html: true,
    //     animation: 'bounce',
    //     backdropClose: true,
    //     okText: 'Yes',
    //     cancelText: 'No',
    //     reverse: true
    //     //loader: true
    //   })
    //   .then(dialog => {
    //     this.IsConfirmAllocation = true;
    //     console.log('Yes...');
    //     this.allocation();
    //   })
    //   .catch(() => {

    //     console.log('NO....');
    //     this.$refs.shipmentNo.focus();
    //     this.IsConfirmAllocation = false;
    //     let payload = {
    //     "ShippingId": (this.shipmentNo).trim(),
    //     "ShipmentType": this.deliveryOption,
    //     "HubId": this.userHubId,
    //     "DeliveryUserId": this.srId,
    //     "Comment": "Tranfered from SR Delivery Sheet page",
    //     "BatchId": null,
    //     "NotificationStatus": "Pending",
    //     "NotificationType": "CSAW",
    //     "IsReversePick": this.deliveryOption == 'RVP' ? '1' : '0',
    //     "ReasonCode": "XBU00272",
    //     "LastmodifiedBy": this.createdBy,
    //     "RaisedFrom": "Operations"
    //     }
    //     axios({
    //       method: 'POST',
    //       url: apiUrl.api_url + 'expose/common/api/push/csaw/data',
    //       data: payload
    //     })
    //     .then(result => {
    //       this.shipmentNo = '';
    //       // if (result.data.code == 200) {
    //       //   this.$alertify.success('');
    //       // } else {
    //       //   this.$alertify.error(result.data.message);
    //       // }
    //     }, error => {
    //       //this.isLoadingAlc = false
    //       console.error(error)
    //     })
    //   });
    // },
    verifyTripClosed(userHubId,srId){
      return new Promise(async function(resolve,reject) {
        let inputData = {
          "XBkey":"XB123",
          "HubId":userHubId,
          "DeliveryUserId":srId
        }
        //console.log('this.input',inputData);
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'expose/trip/tripDetails',
          data: inputData
        })
        .then(result => {
          //console.log('result.data.TripState',result.data.TripState);
          if (result.data.TripState =="deliveryuserclosed" && result.data.code == 200 ) {
            resolve(result.data);
          } else {
            resolve(false);
          }
        }, error => {
          console.error(error)
        })
      })
    },
    async confirmTrip() {
      if(this.deliveryOption == '') {
        this.$alertify.error('Please select delivery option type !');
        $('#deliveryOption').focus();
      } else {
        this.isConfirmLoad = true;
        this.showParentGroupIdShipmentList = [];
        let verifyShipment = await this.verifyTripClosed(this.userHubId,this.srId);
        console.log('verifyShipment',verifyShipment);
        if(verifyShipment == false) {
          this.isAllocationRvp = false
          this.flagShowPreviousShipment = false
          this.srName = this.srItemObj.text
          this.srHubName = this.hubName
          this.routeName = this.routeItemObj.text
          this.startAllocationFlag = true
          this.input = {
          "XBkey":"XB123",
          "sruserid":this.srId.toString(),
          "hubid":this.userHubId,
          "km":this.vehicleOpenKM?this.vehicleOpenKM:0,
          "tripstate":this.tripState,//"created",
          "vehicleno":this.vehicleNo.toUpperCase(),
          "vehicletype":this.vehicleType,
          "triptype":this.deliveryOption,
          "srname":this.srName,
          "isvehiclereplaced":this.isVehicleReplaced,
          "LastModifiedBy":this.createdBy,
          "MarkedFrom":this.fromId,
          "operationType":"lastmile",
          "isHandoverDeliveryUser":1
          }
          if((this.vehicleType=='bike' && this.srVehicleList.length==0) || this.isVehicleReplaced==true) {
            this.input['isvehicleupdated'] = true
          } else {
            this.input['isvehicleupdated'] = false
          }
          // if(this.tripTitle!='Start Trip') {
          //   this.input['isHandoverDeliveryUser'] = 1
          // }
          if(this.vehicleType=='vehicle') {
            this.input['vehiclevendorid'] = this.vehicleVendorId
          }
          //console.log('input',this.input);
          axios({
            method: 'POST',
            url: apiUrl.api_url + 'expose/shipment/confirm',
            data: this.input
          })
          .then(result => {
            if (result.data.code==200) {
              this.isAllocation = false
              this.$alertify.success(result.data.message)
              this.rvpShipmentsModel = false;
              this.resetTrip()
            } else {
              if(result.data.status == 208) {
                this.showGroupIdShipmentModel = true;
                this.pendingGrouptErrorMsg = result.data.message;
                this.showParentGroupIdShipmentList = result.data.data;
              } else {
                this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
              }
            }
            this.isConfirmLoad = false;
          }, error => {
            console.error(error)
            this.isConfirmLoad = false;
          })
        }
        else {
          this.isConfirmLoad = false;
          this.openKM = verifyShipment.OpenKM
          this.openKmImg = verifyShipment.OpenKMImageUrl
          this.closeKmImg = verifyShipment.CloseKMImagUrl
          this.originCloseImg = verifyShipment.CloseKMImagUrl
          this.tripId = verifyShipment.TripId
          this.srVehicleNo = verifyShipment.VehicleNo
          this.openKm = verifyShipment.OpenKM
          this.closeTripModel = true
        }
      }
    },
    // loadSrShipmentDetails(keywordClear='clear') {
    //   this.IsSelectPlanned = false
    //   this.PlannedMapView = false

    //   //this.ActiveTabIndex = 1;
    //   ///this.searchByShippingId = '';
    //   if(keywordClear == 'reload'){
    //     this.PsearchByShippingId = '';
    //     this.searchByShippingId = '';
    //   } else{
    //     this.PsearchByShippingId = '';
    //   }


    //   this.srShipmentList = []
    //   if(this.srId) {
    //     this.isLoadingASL = true
    //     this.input = {
    //       "HubId": this.userHubId.toString(),
    //       "DeliveryUserId": this.srId
    //     }
    //     if(this.deliveryOption!="") {
    //       this.input["ShipmentType"] = this.deliveryOption
    //     }
    //     if(this.searchByShippingId !="") {
    //       this.input["ShippingId"] = this.searchByShippingId.trim()
    //     }
    //     axios({
    //       method: 'POST',
    //       url: apiUrl.api_url + 'expose/get/allocate/shipment/sr/details',
    //       data: this.input
    //     })
    //     .then(result => {
    //       if (result.data.code==200) {
    //         this.srShipmentList = result.data.data;
    //         if(this.srShipmentList.length >= 1) {
    //           this.isAllocation = true
    //         }
    //       } else {
    //         this.isAllocation = false
    //       }
    //       this.isLoadingASL = false
    //     }, error => {
    //       this.isLoadingASL = false
    //       console.error(error)
    //     })
    //   }
    // },
    // PendingShipmentDetailsOnkeyDown(event){
    //   console.log('event');
    //   if(event.keyCode === 13) {
    //     this.loadPendingShipmentList('search','');
    //   }
    // },
    // loadPendingShipmentList(PkeywordClear='reload',DeliveryTabOption='') {
    //   //console.log('this.deliveryOption',DeliveryTabOption);
    //   //if(this.deliveryOption!="" || DeliveryTabOption !='' ) {
    //     if(PkeywordClear == 'reload'){
    //       this.PsearchByShippingId = '';
    //       this.searchByShippingId = '';
    //     } else {
    //       this.searchByShippingId = '';
    //     }

    //     this.isLoadingPSL = true
    //     this.pendingShipmentList = []
    //     if(this.deliveryOption != ''){
    //        this.PendingListdeliveryOpt = this.deliveryOption;
    //        if(this.deliveryOption.toLowerCase() == 'delivery') {
    //          this.PendingTabOptionKey = 0;
    //        } else if(this.deliveryOption.toLowerCase() == 'rvp') {
    //          this.PendingTabOptionKey = 1;
    //        } else if(this.deliveryOption.toLowerCase() == 'dto') {
    //          this.PendingTabOptionKey = 2;
    //        } else if(this.deliveryOption.toLowerCase() == 'rto') {
    //          this.PendingTabOptionKey = 3;
    //        }
    //        this.isFlyerBarcodecheck(this.IsRVPPaperless,this.deliveryOption);
    //     } else if(DeliveryTabOption != '') {
    //       this.PendingListdeliveryOpt = DeliveryTabOption;
    //       this.isFlyerBarcodecheck(this.IsRVPPaperless,DeliveryTabOption);
    //     }


    //     if(this.PendingListdeliveryOpt.toLowerCase() == 'delivery'){
    //         this.PendingListdeliveryOpt = 'Forward';
    //     }

    //     this.input = {
    //       "HubID": this.userHubId.toString(),
    //       "ShipmentType":this.PendingListdeliveryOpt,
    //       "PageNo":this.pageNo
    //     }
    //     if(this.serviceCatagoryOption){
    //       this.input.ServiceCategory = this.serviceCatagoryOption
    //     }
    //     if(this.PsearchByShippingId !="") {
    //       this.input["ShippingId"] = this.PsearchByShippingId.trim()
    //     }
    //     //console.log('this.input',this.input);
    //     axios({
    //       method: 'POST',
    //       url: apiUrl.api_url + 'expose/get/pending/shipment/details',
    //       data: this.input
    //     })
    //     .then(result => {
    //       if (result.data.code==200) {
    //         this.pendingShipmentList = result.data.data
    //         this.totalPendingShipment = result.data.Total
    //         if (this.totalPendingShipment < 20) {
    //           this.pageCount = 1
    //         } else {
    //           this.pageCount = Math.ceil(this.totalPendingShipment / 20);
    //         }
    //       } else{
    //         this.pageCount = 0;
    //       }
    //       this.isLoadingPSL = false
    //     }, error => {
    //       this.isLoadingPSL = false
    //       console.error(error)
    //     })
    //   //}
    // },
    // getPaginationData(pageNum) {
    //   this.pageNo = pageNum;
    //   this.loadPendingShipmentList();
    // },
    closeCloseTripModel() {
      this.closeTripModel = false
    },
    loadOpenImageError(imageSrc, type) {
      var srcLink = "static/img/defaultImg.png"
      // var splitLink = imageSrc.split("id=")
      // if(splitLink.length>0) {
      //   if(splitLink[1]) {
      //     var srcLink = "https://drive.google.com/uc?export=view&id="+splitLink[1]
      //   }
      // }
      this.openKmImg = srcLink
    },
    loadCloseImageError(imageSrc) {
      var srcLink = "static/img/defaultImg.png"
      this.originCloseImg = imageSrc
      this.closeKmImg = srcLink
    },
    verifyTrip() {

      if(this.openKm >= 1000000){
        this.errorOpenKM = "Open Km should be less than 1000000";
      } else {
        this.errorOpenKM = '';
        if(parseFloat(this.closeKm) > parseFloat(this.openKm) ) {
          let calculatekm = parseFloat(this.closeKm) - parseFloat(this.openKm);
          if(calculatekm < 200) {
            this.errorCloseKM = '';
            this.input = {
              "XBkey":"XB123",
              "tripid":this.tripId,
              "sruserid":this.srId.toString(),
              "hubid":this.userHubId,
              "km":this.closeKm,
              "Openkm":this.openKm,
              "tripstate":"closed",
              "vehicleno":this.srVehicleNo,
              "isvehiclereplaced":false,
              // "latitude":this.latitude,
              // "logitude":this.longitude,
              //"speedmeterurl":this.originCloseImg,
              "lastmodifiedby":this.createdBy,
              "operationType":"lastmile"
            }
            //console.log('this.input',this.input);
            axios({
              method: 'POST',
              url: apiUrl.api_url + 'expose/trip/close',
              data: this.input
            })
            .then(result => {
              if (result.data.code==200) {
                this.$alertify.success(result.data.message)
                this.resetTrip()
                this.closeTripModel = false
              } else {
                this.$alertify.error(result.data.message)
              }
            }, error => {
              console.error(error)
            })
          } else {
            this.errorCloseKM = "Travel distance cannot be more than 200 KM/day.!";
          }
        } else {
          this.errorCloseKM = "Close KM should be greater then open KM"
        }
      }
    },
    isVehicleReplaceCheck(event) {
      this.vehicleNoItemObj = {value:'', text: ''}
      this.vehicleNo = ''
      this.vehicleVendorId = 0
      if(event==1) {
        this.isVehicleReplaced=true
      } else {
        this.isVehicleReplacedCheck = 0
        this.isVehicleReplaced=false
      }
    },
    // removeShipment(shippingId) {
    //   if(shippingId) {
    //     this.isLoadingASL = true
    //     this.input = {
    //       "XBkey": "XB123",
    //     "ShippingID": shippingId,
    //     "LastModifiedBy": this.createdBy,
    //     }
    //     axios({
    //         method: 'POST',
    //         url: apiUrl.api_url + 'expose/shipment/remove',
    //         data: this.input
    //       })
    //       .then(result => {
    //         if (result.data.code==200) {
    //           this.loadSrShipmentDetails()
    //           this.$alertify.success("Shipment Successfully Removed")
    //         } else {
    //           this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
    //         }
    //         this.isLoadingASL = false
    //       }, error => {
    //         this.isLoadingASL = false
    //         console.error(error)
    //       })
    //   } else {
    //     this.$alertify.error("Shipment ID not found")
    //   }
    // },
    isSameDayDelivery(flag) {
      var response = "No"
      if(flag) {
        var response = "Yes"
      }
      return response;
    },
    // fullScreenPendingShipmentList() {
    //   this.pendingShipModel = true
    //   this.PopUpsearchByShippingId = '';
    //   this.pendingShipmentListMdl = '';
    //   //console.log('this.PendingListdeliveryOpt',this.PendingListdeliveryOpt);
    //   if(this.PendingListdeliveryOpt != 'RVP'){
    //     this.loadPendingShipmentListModel(this.PendingListdeliveryOpt);
    //   }
    //   this.searchByShippingId = '';
    // },
    // closePendingShipModel() {
    //   this.pendingShipModel = false
    //   this.PopUpsearchByShippingId = '';
    //   this.pendingShipmentListMdl = '';
    // },
    // getPaginationDataModel(pageNum) {
    //   this.pageNoMdl = pageNum;
    //   this.loadPendingShipmentListModel(this.mdlPopDeliveryOption);
    // },
    // SearchPopShipmentDetails(e){
    //   if(event.keyCode === 13) {
    //     this.loadPendingShipmentListModel('','');
    //   }
    // },
    // loadPendingShipmentListModel(deliveryTabTypeOption,searchKey) {
    //   this.isLoadingPSLModel = true
    //   this.pendingShipmentListMdl = []

    //   if(this.deliveryOption != ''){
    //      this.mdlPopDeliveryOption = this.deliveryOption;
    //      this.isFlyerBarcodecheck(this.IsRVPPaperless,this.deliveryOption);
    //   } else if(deliveryTabTypeOption != ''){
    //     this.mdlPopDeliveryOption = deliveryTabTypeOption;
    //     this.isFlyerBarcodecheck(this.IsRVPPaperless,deliveryTabTypeOption);
    //   }

    //   if(this.mdlPopDeliveryOption.toLowerCase() == 'delivery' || this.mdlPopDeliveryOption.toLowerCase() == 'Forward') {
    //     this.PendingPopTabOptionKey = 0;
    //   } else if(this.mdlPopDeliveryOption.toLowerCase() == 'rvp') {
    //     this.PendingPopTabOptionKey = 1;
    //   } else if(this.mdlPopDeliveryOption.toLowerCase() == 'dto') {
    //     this.PendingPopTabOptionKey = 2;
    //   } else if(this.mdlPopDeliveryOption.toLowerCase() == 'rto') {
    //     this.PendingPopTabOptionKey = 3;
    //   }

    //   if(this.mdlPopDeliveryOption.toLowerCase() == 'delivery'){
    //       this.mdlPopDeliveryOption = 'Forward';
    //   }
    //   this.input = {
    //     "HubID": this.userHubId.toString(),
    //     "ShipmentType": this.mdlPopDeliveryOption,
    //     "PageNo":this.pageNoMdl
    //   }
    //   if(this.PopUpsearchByShippingId !="") {
    //     this.input["ShippingId"] = this.PopUpsearchByShippingId.trim()
    //   }
    //   axios({
    //     method: 'POST',
    //     url: apiUrl.api_url + 'expose/get/pending/shipment/details',
    //     data: this.input
    //   })
    //   .then(result => {
    //     if (result.data.code==200) {
    //       this.pendingShipmentListMdl = result.data.data
    //       this.totalPendingShipmentMdl = result.data.Total
    //       if (this.totalPendingShipmentMdl < 20) {
    //         this.pageCountMdl = 1
    //       } else {
    //         this.pageCountMdl = Math.ceil(this.totalPendingShipmentMdl / 20);
    //       }
    //     } else{
    //       this.pageCountMdl = 0
    //     }
    //     this.isLoadingPSLModel = false
    //   }, error => {
    //     this.isLoadingPSLModel = false
    //     console.error(error)
    //   })
    // },
    selectSRFlt(obj) {
      this.srItemObjFlt = obj
      this.srIdFlt = obj.value
      this.srShipmentPrintList = []
    },
    selectFromFlt(obj) {
      this.fromItemObjFlt = obj
      this.fromIdFlt = obj.value
      this.srShipmentPrintList = []
    },
//     selectDeliveryOptionPrint(obj) {
//       this.srShipmentPrintList = []
//       this.batchIdListPrint = [];
//       this.deliveryOptionItemObjPrint = obj;
//       this.deliveryOptionPrint = obj.text;
//       let fromrvpdate = moment().subtract(1, 'days').format('YYYY-MM-DD');
//       let torvpdate = moment().format('YYYY-MM-DD');
//       this.showconfirmPrint = false
//     },
//     printShipmentForDelivery() {
//       this.srShipmentPrintList = []
//       this.showconfirmPrint = false
//       if(this.deliveryOptionPrint == ''){
//         return this.$alertify.error('Please select Delivery Option');
//       }
//     //  if(this.deliveryOptionPrint == 'RVP' && this.batchIdPrint == ''){
//     //    return this.$alertify.error('Please select Batch Id');
//     //  }
//       // this.printType = dType;
//       // this.printDType = dType
//       // if(dType=="delivery" && (this.deliveryOptionPrint=='RTO' || this.deliveryOptionPrint=='DTO')) {
//       //   this.printDType = "printRTORunsheet";
//       // } else if (dType=="delivery" && this.deliveryOptionPrint=='RVP') {
//       //   this.printDType = "printRVP";
//       // }
//       // this.rtoDtoDrsTitle='RTO DRS';
//       // this.rtoDtoSheetTitle='RTO Sheet';
//       // if(this.deliveryOptionPrint=='DTO') {
//       //   this.rtoDtoDrsTitle='DTO DRS';
//       //   this.rtoDtoSheetTitle='DTO Sheet';
//       // }
//       this.srShipmentPrintList = []
//       var selectedSrDtl = this.srArrayList.filter(n=>{
//         return n.userid==this.srIdFlt
//       })
//       this.srNameShipPrint = selectedSrDtl[0].FirstName+" "+selectedSrDtl[0].LastName+" ("+selectedSrDtl[0].userid+")"
//       this.srPhoneShipPrint = selectedSrDtl[0].MobileNumber?selectedSrDtl[0].MobileNumber.toString():""
//       // if ((this.deliveryOptionPrint=='RVP' || this.deliveryOptionPrint=='RTO' || this.deliveryOptionPrint=='DTO')) {
//         if(this.batchCreatedDate == ''){
//           return this.$alertify.error('Please select Created Date');
//         }
//         this.batchIdListPrint = [];
//         this.shippingIDArray = [];
//         this.isLoadBatch = true;
//         let batchCdate =  moment(this.batchCreatedDate).format('YYYY-MM-DD');
//         this.today = new Date();
//         let Today = moment(this.today).format('YYYY-MM-DD');
//         if(batchCdate < Today){
//           this.pastdate = true;
//           this.futuredate = false;
//         }
//         else {
//           this.futuredate = true;
//           this.pastdate = false;
//         }
//         let batchpayload = {
//           "UserHubID": this.userHubId.toString(),
//           "DeliveryUserID": this.srIdFlt,
//           "shipmentType":this.deliveryOptionPrint,
//           "createdDate":batchCdate
//           //"FromDate": fromrvpdate,
//           //"ToDate": torvpdate
//         }
//         axios({
//           method: 'POST',
//           url: apiUrl.api_url + 'expose/get/batchid',
//           data: batchpayload
//         })
//         .then(result => {
//           console.log(result);
//           if (result.data.code==200) {
//             this.isLoadBatch = false
//             for (var i = 0; i < result.data.PrintBatchId.length; i++) {
//               this.shippingIDArray = []
//               for(var j=0 ;j<result.data.PrintBatchId[i].NoOfShipments; j++){
//                 this.shippingIDArray.push({
//                   shippingIDArray : result.data.PrintBatchId[i].ShippingIDs[j].ShippingID
//                   })
//                 }
//                   this.batchIdListPrint.push({
//                     AssignBatchNo : result.data.PrintBatchId[i].AssignBatchNo,
//                     NoOfShipments : result.data.PrintBatchId[i].NoOfShipments,
//                    shippingIDArray : this.shippingIDArray
//                   })
//                 }
//               }
//            else {
//             this.isLoadBatch = false
//             this.$alertify.error(result.data.message)
//           }
//         }, error => {
//           console.error(error)
//         })
// //       }
// //       else{
// //         this.showconfirmPrint = true,
// //         this.isLoadingPrint = true
// //     //  this.fromIdFlt = this.fromItemObjFlt.value
// //       this.input = {
// //         "DeliveryUserID" : this.srIdFlt,
// //         "PrintFrom": this.fromIdFlt,
// //         "ShipmentType": this.deliveryOptionPrint
// // //        "BatchId": this.batchIdPrint
// //       }
// //       axios({
// //         method: 'POST',
// //         url: apiUrl.api_url + 'expose/web/get/shipmentbysrid',
// //         data: this.input
// //       })
// //       .then(async result => {
// //         if (result.data.code==200) {
// //           this.srShipmentPrintList = result.data.data
// //           // this.RVPLink = result.data.RVPRunsheetPDFLink;
// //           // this.apiPath = await apiUrl.api_url +'expose/web/get/pdf?Filename='+this.RVPLink;
// //           // pathPDF = this.apiPath
// //
// //           if(this.srShipmentPrintList.length>0) {
// //             this.rtoDRSBatchId=this.srShipmentPrintList[0].AssignBatchNo
// //             this.rtoDRSClientName=''
// //             this.rtoDRSVendorName=this.srShipmentPrintList[0].RTOName
// //             this.rtoDRSWHHandOverPersonName=''
// //             this.rtoRunSTHubName=this.srShipmentPrintList[0].HubName
// //             this.rtoRunSTDrsNo=this.srShipmentPrintList[0].AssigneBatchNo
// //           }
// //           // if(this.deliveryOptionPrint=='RVP'){
// //           //    alert("Generating PDF...! Please Wait to open...")
// //           //    setTimeout(function(){
// //           //      window.open(pathPDF);
// //           // }, 5000);
// //           //  }
// //         } else {
// //           this.$alertify.error(result.data.message)
// //         }
// //         this.isLoadingPrint = false
// //       }, error => {
// //         console.error(error)
// //       })
// //     }
//     },
//     printShipmentForRVP(AssignBatchNo,pdfType){
//       let responseType = 'blob';
//       this.srShipmentPrintList = []
//       this.isLoadPDF = true

//       this.input = {
//         "DeliveryUserID" : this.srIdFlt,
//       //  "PrintFrom": this.fromIdFlt,
//         "ShipmentType": this.deliveryOptionPrint,
//         "BatchId": AssignBatchNo,
//       //  "PrintType":pdfType,
//         "UserName":this.createdBy
//       }
//       if(pdfType == 'olddrs'){
//         this.input.SheetType = pdfType
//       }
//       else {
//         this.input.PrintType = pdfType
//       }
//       if(this.deliveryOptionPrint == "Delivery"){
//         this.input.PrintFrom = 'FromWeb';
//       }
//       axios({
//         method: 'POST',
//         url: apiUrl.api_url + 'expose/web/get/shipmentbysrid',
//         data: this.input,
//         responseType: responseType
//       })
//       .then(async result => {
//            if(result.status == 200 ) {
//             const downloadUrl = window.URL.createObjectURL(new Blob([result.data], { type: 'application/pdf' }))
//             let message = {
//                 title: '',
//                 body: `<p>Pdf is generated, Would you like to open.!</p>`,
//               };

//               let res = this.$dialog.alert(message, {
//                 html: true,
//                 animation: 'bounce',
//                 backdropClose: false,
//                 loader: true
//               })
//               .then(dialog => {
//                   window.open(downloadUrl);
//                   this.isLoadPDF = false
//                   dialog.close();
//               })
//               .catch(() => {
//                 this.isLoadPDF = false
//               })
//           } else {
//             this.isLoadPDF = false;
//             this.$alertify.error('Unable to load pdf, Please try after sometime.!');
//           }
//       }, error => {
//         this.isLoadPDF = false;
//         console.error(error)
//       })
//     },
//     exportCSVOfShippingIDS(result) {
//       let csvContent = "data:text/csv;charset=utf-8,";
//       var today = new Date();
//       var dd = today.getDate();
//       var mm = today.getMonth() + 1;
//       var yyyy = today.getFullYear();
//       var today = dd + "" + mm + "" + yyyy;
//       let filename = "ShippingID" + today + ".csv";
//       csvContent += ['ShippingID',
//     //    Object.keys(result).join(";"),
//         ...result.map(item => Object.values(item).join(";"))
//       ]
//       .join("\n")
//       .replace(/(^\[)|(\]$)/gm, "");

//       const data = encodeURI(csvContent);
//       const link = document.createElement("a");
//       link.setAttribute("href", data);
//       link.setAttribute("download", filename);
//       link.click();
//     },
    // printShipments() {
    //   const d = new Printd();
    //   var buffer = '';
    //
    //   var cssText = `
    //        body{
    //            -webkit-print-color-adjust:exact;
    //            font-family: Roboto,sans-serif;
    //        }
    //        table {
    //            border-collapse: collapse;
    //            margin-left:0px !important;
    //        }
    //        table, td, th {
    //          border-style: solid;
    //          border-width: 1px;
    //          padding:2px;
    //        }
    //        .text-right{
    //          text-align:right;
    //        }
    //        .text-left{
    //          text-align:left;
    //        }
    //        .td-width{
    //          width:10px!important;
    //        }
    //        .text-center{
    //          text-align:center;
    //        }
    //        .h3-center-text{
    //          text-align:center;
    //        }
    //
    //
    //        .tbl-fs16 {
    //          font-size:16px;
    //          font-weight:bold
    //        }
    //        td span {
    //          font-size:14px !important;
    //        }
    //
    //        @media print {
    //        .text-primary th{
    //          background-color:rgb(226, 216, 216) !important;
    //          color:black !important;
    //          font-size:20px !important;
    //        }
    //        .pagebreak { page-break-before: always; }
    //       }
    //       `
    //   d.print(document.getElementById('printShipmentContent'), cssText);
    // },
    // printShipDateTime() {
    //   return moment().format('DD-MM-YYYY') +" @ "+ moment().format('HHmm')
    // },
    currentDate() {
      return moment().format('DD-MM-YYYY');
    },
    currentTime() {
      return moment().format('HH:mm:ss');
    },
    // closeShipmentModel() {
    //   this.showShipmentModel=false
    //   this.showRouteShipmentModel=false
    // },
    // ShowShipments() {
    //   this.showShipmentModel = true
    //   this.isPodsLoader = true;
    //   this.showShipmentList = []
    //   this.input = {
    //     "DeliveryUserId": this.srId
    //   }
    //   axios({
    //     method: 'POST',
    //     url: apiUrl.api_url + 'expose/shipment/previous',
    //     data: this.input
    //   })
    //   .then(result => {
    //     if (result.data.code==200) {
    //       this.showShipmentList = result.data.data
    //     } else {
    //       this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
    //     }
    //     this.isPodsLoader = false;
    //   }, error => {
    //     console.error(error)
    //   })
    // },
    clearTrip(){
      this.allocationSuccessMsg = "",
      this.allocationErrorMsg = "",
      this.errorAllocationCount = "",
      this.successAllocationCount = "",
      this.loadSRList(this.userHubId);
      let clearStatus = this.resetTrip();
      this.isResetLoad = true;
      if(clearStatus){
        console.log('lodaer off',clearStatus);
        this.isResetLoad = false;
      }
    },
    resetTrip() {
      this.isVehicleReplacedCheck = 0
      this.isVehicleReplaced=false
      this.errVehicleNo = ""
      this.errVehicleKm = ""
      this.tripTitle = 'Start Trip'
      this.isRSVSr = 0
      this.srId = ''
      this.srName = ''
      this.srItemObj = { value: "",text: ""}
      this.routeId = ''
      this.routeName = ''
      this.routeItemObj = { value: "",text: ""}
      this.startTripFlag = false
      this.vehicleTypeFlag = false
      this.vehicleType = ""
      this.vehicleNoItemObj = {value:'', text: ''}
      this.vehicleNo = ''
      this.vehicleVendorId = 0
      this.vehicleOpenKM = ''
      this.startAllocationFlag = false

      this.deliveryOptionItemObj = { text: ""}
      this.deliveryOption = ""
      this.clientOptionItemObj = {value: "",text: ""}
      this.clientOption = ""
      this.shipmentNo = ''
      this.isAllocation = false
      this.fromItemObj = { value: "UA",text: "From Mobile"}
      this.fromId = "UA"

      this.tripId = ''
      this.openKm = ''
      this.openKmImg = ''
      this.closeKm = ''
      this.closeKmImg = ''
      this.originCloseImg = ''
      this.latitude = ''
      this.longitude = ''
      this.srVehicleNo = ''
      this.errorCloseKM = ''
      this.errorOpenKM = ''

      this.srShipmentList = []
      this.flagShowPreviousShipment = false

      this.fromToDate= ''
      this.fltpickup= 'Pending'
      this.selectedPickups= []
      this.selectedPickupsMore=[]
      this.pendingShipmentList = []
      this.totalPendingShipment = 0
      this.currentDateTime = '',
      this.tripDayflag = '',
      this.tripCreatedDate = '',
      this.tripDateFlag = false,
      this.IsSRNeedTrip = true
      // this.resetBulkAllocation()
      this.serviceCatagoryObj = {value:'',text:''},
      this.serviceCatagoryOption = ''
      this.isCreate = false
      this.buttonStatus = '',
      this.isCreateRoute = false,
      // this.IsSelectRoute = false
      this.showRouteShipmentList = ''
      this.showUnplannedShipments = ''
      this.EditReAssignSRModelLoader = false
      this.errors.clear();
      this.$validator.reset();

      return true;
    },
    // selectAll() {
    //   if (this.sAll) {
    //     this.pickupList.forEach((data) => {
    //       this.selectedPickups.indexOf(data.ShippingId) == -1 ? this.selectedPickups.push(data.ShippingId) : ''
    //     })
    //   } else {
    //     this.selectedPickups = []
    //   }
    // },
    // selectAllMoreRVPShipments() {
    //   if (this.sAllMoreShip) {
    //     this.suggestRVPArrayList.forEach((data) => {
    //       this.selectedPickupsMore.indexOf(data.ShippingId) == -1 ? this.selectedPickupsMore.push(data.ShippingId) : ''
    //     })
    //   } else {
    //     this.selectedPickupsMore = []
    //   }
    // },
    // closeRvpShipmentsModel() {
    //   this.tabIndex = 0;
    //   this.clientOptionItemObj = {value: "",text: ""}
    //   this.clientOption = ""
    //   this.deliveryOptionItemObj = { text: ""}
    //   this.deliveryOption = ""
    //   this.$validator.reset();
    //   this.rvpShipmentsModel = false;
    // },
    // showPendingPickups() {
    //   this.PendingPopTabOptionKey = 1;
    //   this.PendingListdeliveryOpt = 'RVP';
    //   this.indexTab = 1;
    //   this.fromId="UA",
    //   this.fromItemObj = { value: "UA",text: "From Mobile"}
    //   this.isLoadingRvpPickup = true
    //   this.errorRvpAllocation = '';
    //   this.successRvpAllocation = '';
    //   this.searchByShippingIdRvp = '';
    //   this.searchByShippingIdRvpASL = '';
    //   this.pickupList = []
    //   this.selectedPickups = []
    //   this.selectedPickupsMore = []
    //   this.morePendingRVPShipmentsModel = false
    //   this.isActiveRvp=false
    //   this.sAll = ''
    //   this.fromDate = null;
    //   this.toDate = null;
    //   this.isFlyerBarcodecheck(this.IsRVPPaperless,this.PendingListdeliveryOpt);
    //   if(this.fromToDate) {
    //     this.fromDate = this.fromToDate[0]?moment(this.fromToDate[0]).format('YYYY-MM-DD'):null;
    //     this.toDate = this.fromToDate[1]?moment(this.fromToDate[1]).format('YYYY-MM-DD'):null;
    //   }
    //   this.input = {
    //     "hubid": this.userHubId,
    //     "shipmenttype": "Reverse",
    //     "status": this.fltpickup,
    //     "clientbusinessdetailid": null,
    //     "FromDate": this.fromDate,
    //     "ToDate": this.toDate
    //   }
    //   axios({
    //     method: 'POST',
    //     url: apiUrl.api_url + 'expose/shipment/reversepending/list',
    //     data: this.input
    //   })
    //   .then(result => {
    //     if (result.data.code==200) {
    //       this.pickupList = result.data.data;
    //     } else {
    //       this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
    //     }
    //     this.isLoadingRvpPickup = false
    //   }, error => {
    //     this.isLoadingRvpPickup = false
    //     console.error(error)
    //   })
    // },
    // loadRVPAllocatedShipmentList(){
    //   this.indexTab = 2
    //   this.RVPAllocatedShipmentList = [];
    //   this.searchByShippingIdRvp = '';
    //   this.searchByShippingIdRvpASL = '';
    //   //this.srShipmentList = []
    //   if(this.srId) {
    //     this.isLoadingASL = true
    //     this.input = {

    //       "HubId": this.userHubId.toString(),
    //       "DeliveryUserId": this.srId
    //     }
    //     if(this.deliveryOption!="") {
    //       this.input["ShipmentType"] = this.deliveryOption
    //     }
    //     // if(this.searchByShippingId !="") {
    //     //   this.input["ShippingId"] = this.searchByShippingId
    //     // }
    //     //console.log('this.input',this.input);
    //     axios({
    //       method: 'POST',
    //       url: apiUrl.api_url + 'expose/get/allocate/shipment/sr/details',
    //       data: this.input
    //     })
    //     .then(result => {
    //       if (result.data.code==200) {
    //         this.RVPAllocatedShipmentList = result.data.data;
    //         if(this.RVPAllocatedShipmentList.length >= 1) {
    //           this.isAllocationRvp = true
    //         }
    //       } else {

    //         this.isAllocationRvp = false
    //       }
    //       this.isLoadingASL = false
    //     }, error => {
    //       this.isLoadingASL = false
    //       console.error(error)
    //     })
    //   }
    // },
    // selectPickups(obj) {
    //   this.pickupItem = obj
    //   this.fltpickup = obj.value
    // },
    // checkPendingForRVP() {
    //   this.selectedPickupsMore=[]
    //   this.getPendingForRVPList().then( (result) => {
    //     if(result.success) {
    //       this.morePendingRVPShipmentsModel = true
    //       this.isActiveRvp=true
    //     } else {
    //       this.allocatePickup()
    //     }
    //   });
    // },
    // allocatePickup() {
    //   this.selectedPickups = this.selectedPickups.concat(this.selectedPickupsMore)
    //   var self = this;
    //   this.errorRvpAllocation = "";
    //   this.successRvpAllocation = '';
    //   this.errorRvpAllocationErrorArrobj = [];
    //   this.ShipmentFutureFailedArrObj = [];
    //   this.ShipmentFailedArrObj = [];
    //   if(this.selectedPickups.length>0) {
    //     this.isLoadingRvpPickup = true
    //     this.resArray = [];
    //     var successCount = 0;
    //     var failCount = 0;
    //     var failCountFutureDate = 0;
    //     var failShipmentsFDArray = [];
    //     var failShipmentsArray = [];

    //     let chain = Promise.resolve();
    //     for(let val of this.selectedPickups) {
    //       chain = chain.then(() => self.bulkAllocation(val));
    //     }
    //     chain.then(() => {
    //       var result = this.resArray
    //       //console.log('result',result);
    //       for (var i = 0; i < result.length; i++) {
    //         if (result[i].statusCode==206) {
    //           failShipmentsFDArray.push(result[i].shippingId)
    //           failCountFutureDate++;
    //             this.ShipmentFutureFailedArrObj.push(result[i]);
    //         } else if (result[i].statusCode==200) {
    //           successCount++;
    //         } else {
    //           failCount++;
    //           this.ShipmentFailedArrObj.push(result[i]);
    //         }
    //       }
    //       if(failCount>0) {
    //         self.errorRvpAllocation = failCount+" shipping ids cannot assign for pickup."
    //         this.errorRvpAllocationErrorArrobj = this.ShipmentFailedArrObj;
    //       }
    //       if(failCountFutureDate>0) {
    //         self.errorRvpAllocation = failCountFutureDate+" these shipping ids cannot assign for pickup, because pickup date set as a future date.";
    //         this.errorRvpAllocationErrorArrobj = this.ShipmentFutureFailedArrObj;
    //       }
    //       if(successCount>0) {
    //         this.isAllocationRvp = true;
    //         this.morePendingRVPShipmentsModel = false
    //         this.isActiveRvp=false
    //         self.successRvpAllocation = successCount+" shipments allocated successfully";
    //       }
    //       this.isLoadingRvpPickup = false;
    //     }).catch(err=>{
    //       self.errorRvpAllocation = err.message;
    //       this.isLoadingRvpPickup = false;
    //     });
    //   }
    // },
    // bulkAllocation(shippingId) {
    //   if($("#CI"+shippingId).val()!=undefined && $("#CI"+shippingId).val()!="") {
    //     var clientId = $("#CI"+shippingId).val();
    //     return new Promise( (resolve, reject) => {
    //       this.files = []
    //       var selectedSrDtl = this.srArrayList.filter(n=>{
    //         return n.userid==this.srId
    //       })
    //       this.input = {
    //         "XBkey":"XB123",
    //       "HubId":this.userHubId.toString(),
    //       "DeliveryUserId":this.srId,
    //       "OldDeliveryUserOrUserId":selectedSrDtl[0].OldDeliveryUserOrUserId?selectedSrDtl[0].OldDeliveryUserOrUserId.toString():"0",
    //       "DeliveryUserName":this.srName,
    //       "ShippingID":shippingId,
    //       "LastModifiedBy":this.createdBy,
    //       "IsConfirmAllocation":false,
    //       "AllocationType":this.deliveryOption,
    //         "EmpType":selectedSrDtl[0].EmpType?selectedSrDtl[0].EmpType:"",
    //       "MarkedFrom":"Web",//this.fromId,
    //       "CourierCompanyID":selectedSrDtl[0].CourierCompanyID?selectedSrDtl[0].CourierCompanyID.toString():'null',
    //       "IsRSVCSr":this.isRSVSr,
    //       "MobileNo":selectedSrDtl[0].MobileNumber?selectedSrDtl[0].MobileNumber.toString():"",
    //         "isTripAllowedForSR": this.IsSRNeedTrip,
    //         "IsRVPPaperless": this.IsRVPPaperless
    //       }
    //       if(this.deliveryOption!="Delivery") {
    //         this.input["ClientId"] = clientId
    //       }
    //       axios({
    //         method: 'POST',
    //         url: apiUrl.api_url + 'expose/shipment/allocate',
    //         data: this.input
    //       })
    //       .then(result => {

    //         var result = result.data
    //         if(result.status==204) {
    //           this.resArray.push({"success":false, "statusCode":result.status, "message":result.message, "shippingId":shippingId});
    //           resolve({"success":false, "statusCode":result.status, "message":result.message, "shippingId":shippingId});
    //           //reject({"success":false, "statusCode":result.status, "message":result.message, "shippingId":shippingId});
    //         } else if (result.status==206) {
    //           this.resArray.push({"success":false, "statusCode":result.status, "message":result.message, "shippingId":shippingId})
    //           resolve();
    //         } else if (result.code==200) {

    //           //tracker api called here
    //           let TrackerInfo = {
    //               projectname:"Last Mile",
    //               type:"Web",
    //               userid:this.userid,
    //               username:this.createdBy,
    //               meta: {
    //                   "event":"rvpallocation",
    //                   "shipment": shippingId,
    //                   "allocationtype": "RVP",
    //                   "srid": this.srId
    //               }
    //           }
    //           this.PageTracker(TrackerInfo)
    //           //end

    //           $("#rvpTr"+shippingId).remove();
    //           for (var i = 0; i < this.selectedPickups.length; i++) {
    //             if(this.selectedPickups[i]==shippingId) {
    //               this.selectedPickups.splice(i, 1);
    //             }
    //           }
    //           this.resArray.push({"success":true, "statusCode":result.code, "message":result.message, "shippingId":shippingId})
    //           resolve();
    //         } else {
    //           this.resArray.push({"success":false, "statusCode":result.code, "message":result.message, "shippingId":shippingId})
    //           resolve();
    //         }
    //       }, error => {
    //         console.error(error)
    //         reject({"success":false, "statusCode":null, "message":"server error, Try later"});
    //       })
    //     })
    //   } else {
    //     reject({"success":false, "statusCode":null, "message":"ClientId not found"});
    //   }
    // },
    // getPendingForRVPList() {
    //   this.errorRvpAllocation = "";
    //   this.successRvpAllocation = '';
    //   return new Promise( (resolve, reject) => {
    //     this.suggestRVPArrayList = []
    //     var relShippingIds = []
    //     axios({
    //       method: 'POST',
    //       url: apiUrl.api_url + 'expose/get/rvp/shipments',
    //       data: {ShippingID:this.selectedPickups}
    //     })
    //     .then(response => {
    //       var resultData = response.data
    //       if(resultData.code == 200 && typeof resultData.data !== 'undefined') {
    //         var result = resultData.data
    //         for (var i = 0; i < result.length; i++) {
    //           if(result[i].ReversePickUpData.length>0) {
    //             let tempData = result[i].ReversePickUpData
    //             for (var j = 0; j < tempData.length; j++) {
    //               relShippingIds.push(tempData[j])
    //             }
    //           }
    //         }
    //         if(relShippingIds.length>0) {
    //           for (var i = 0; i < relShippingIds.length; i++) {
    //             for (var j = 0; j < this.selectedPickups.length; j++) {
    //               if(relShippingIds[i]==this.selectedPickups[j]) {
    //                 relShippingIds.splice(i,1);
    //               }
    //             }
    //           }
    //           var uniqueArray = []
    //           for (var i = 0; i < relShippingIds.length; i++) {
    //             if(uniqueArray.indexOf(relShippingIds[i]) === -1) {
    //               uniqueArray.push(relShippingIds[i]);
    //             }
    //           }
    //           // console.log(uniqueArray.length);
    //           // console.log(this.pickupList.length);
    //           var suggestRVPArrayList=[]
    //           for (var i = 0; i < this.pickupList.length; i++) {
    //             if(uniqueArray.includes(this.pickupList[i].ShippingId)) {
    //               this.suggestRVPArrayList.push(this.pickupList[i]);
    //             }
    //           }
    //           resolve({success:true});
    //         }
    //       } else {
    //         resolve({success:false});
    //       }
    //     }, error => {
    //       resolve({success:false});
    //     })
    //   });
    // },
    // closeMPRVPShipments() {
    //   this.morePendingRVPShipmentsModel = false
    //   this.isActiveRvp=false
    //   this.errorRvpAllocation=''
    //   this.successRvpAllocation=''
    // },
    // resetBulkAllocation() {
    //   this.fromToDate= ''
    //   this.fltpickup= 'Pending'
    //   this.selectedPickups= []
    //   this.selectedPickupsMore = []
    //   this.pickupList= []
    //   this.pickupItem= {value:'Pending',text:'All Pending'}
    // },
    // loadRVPShipmentDetails(){
    //   var searchvalue = this.searchByShippingIdRvp.toLowerCase();
    //   $("#shipmentListRvp tbody tr").filter(function() {
    //     $(this).toggle($(this).text().toLowerCase().indexOf(searchvalue) > -1)
    //   });
    // },
    // loadRVPAllocatedShipmentDetails(){
    //   var searchallocated = this.searchByShippingIdRvpASL.toLowerCase();
    //   $("#shipmentListRvpAllocated tbody tr").filter(function() {
    //     $(this).toggle($(this).text().toLowerCase().indexOf(searchallocated) > -1)
    //   });
    // },
    // selectBatchIdPrint(obj) {
    //   this.batchIdItemObjPrint = obj
    //   this.batchIdPrint = obj.text
    //   this.srShipmentPrintList = []
    // },
    // resetPrint(){
    //     this.deliveryOptionItemObjPrint = '';
    //     this.srItemObjFlt = ''
    //     this.srIdFlt = false
    //     this.deliveryOptionPrint = ''
    //     this.srShipmentPrintList = []
    //     this.isLoadBatch = false
    //     this.isLoadingPrint = false
    //     this.batchIdListPrint = []
    //     this.batchCreatedDate = ''
    //     this.showconfirmPrint = false;
    // },
    async switchPlannedAllocationPanel(currentVal){
      // console.log('currentVal --->>', currentVal);
      this.currentScreenTab = currentVal;
      if(currentVal == 'listview') {
        this.ViewPlannedList();
        // this.currentScreenTab = 'listview'
        // this.PlannedListView = true
        // this.PlannedMapView = false
      } else if (currentVal == 'allocationview') {
        this.ViewPlannedMap();
        // this.currentScreenTab = 'allocationview'
        // this.PlannedMapView = true
        // this.PlannedListView = false
        this.ShowAssignedToSRList();
        this.routeId = '';
        this.routeName = '';
        this.routeItemObj = { value: "",text: ""}
      }
      // this.isResetLoad = true
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/RouteAllocation/RouteAllocation.js